import React from "react"

const iconOptions = {
  "01_general-01": (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="114" viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M100.8 57.6v43.2c0 3.976-3.224 7.2-7.2 7.2H14.4c-3.976 0-7.2-3.224-7.2-7.2V57.6"
            transform="translate(-111.000000, -133.000000) translate(114.000000, 136.000000)"
          />
          <path
            stroke="#8451EC"
            d="M97.91 0H10.09C8.402.001 6.94 1.172 6.57 2.82L0 32.4c0 5.965 4.835 10.8 10.8 10.8 5.965 0 10.8-4.835 10.8-10.8 0 5.965 4.835 10.8 10.8 10.8 5.965 0 10.8-4.835 10.8-10.8 0 5.965 4.835 10.8 10.8 10.8 5.965 0 10.8-4.835 10.8-10.8 0 5.965 4.835 10.8 10.8 10.8 5.965 0 10.8-4.835 10.8-10.8 0 5.965 4.835 10.8 10.8 10.8 5.965 0 10.8-4.835 10.8-10.8l-6.58-29.58c-.362-1.648-1.823-2.822-3.51-2.82z"
            transform="translate(-111.000000, -133.000000) translate(114.000000, 136.000000)"
          />
          <path
            stroke="#522181"
            d="M7.2 79.2L68.4 79.2M68.4 108L68.4 57.6"
            transform="translate(-111.000000, -133.000000) translate(114.000000, 136.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "01_general-02": (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="99" viewBox="0 0 114 99">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M78.16 69.298L56.6 91.788c-.68.71-1.618 1.11-2.6 1.11s-1.92-.4-2.6-1.11l-21.56-22.5M3.46 40.518c-4.386-7.863-4.603-17.385-.58-25.44h0C6.791 7.25 14.229 1.778 22.867.375 31.506-1.027 40.292 1.81 46.48 7.998l7.52 7.49 7.52-7.51c6.188-6.19 14.975-9.027 23.615-7.627 8.64 1.4 16.08 6.87 19.995 14.697h0c4.02 8.056 3.802 17.576-.58 25.44"
            transform="translate(-377.000000, -141.000000) translate(380.000000, 144.000000)"
          />
          <path
            stroke="#8451EC"
            d="M0 54.898h31.29c.682-.003 1.305-.39 1.61-1l8.27-16.54c.324-.674 1.035-1.074 1.78-1 .745.066 1.372.582 1.58 1.3l8.07 26.87c.234.705.874 1.195 1.615 1.237.742.042 1.433-.373 1.745-1.047l7.53-17.59c.27-.607.848-1.02 1.51-1.08.66-.062 1.3.241 1.67.79l5.33 8.01h36"
            transform="translate(-377.000000, -141.000000) translate(380.000000, 144.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "01_general-03": (
    <svg xmlns="http://www.w3.org/2000/svg" width="115" height="116" viewBox="0 0 115 116">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M29.19 88.31L79.89 88.31M62.55 35.19L88.06 75.27M46.53 35.19L21.02 75.27"
            transform="translate(-639.000000, -132.000000) translate(642.000000, 135.000000)"
          />
          <path
            stroke="#8451EC"
            d="M12.65 97.48c4.534 0 8.21-3.676 8.21-8.21 0-4.534-3.676-8.21-8.21-8.21-4.534 0-8.21 3.676-8.21 8.21-.003 2.178.861 4.268 2.402 5.808 1.54 1.54 3.63 2.405 5.808 2.402zM25.34 109.41c-1.9-5.368-6.976-8.956-12.67-8.956S1.9 104.042 0 109.41M96.27 97.48c4.534 0 8.21-3.676 8.21-8.21 0-4.534-3.676-8.21-8.21-8.21-4.534 0-8.21 3.676-8.21 8.21 0 4.534 3.676 8.21 8.21 8.21zM108.94 109.41c-1.9-5.368-6.976-8.956-12.67-8.956s-10.77 3.588-12.67 8.956M54.34 16.42c4.534 0 8.21-3.676 8.21-8.21 0-4.534-3.676-8.21-8.21-8.21-4.534 0-8.21 3.676-8.21 8.21 0 4.534 3.676 8.21 8.21 8.21zM67.01 28.35c-1.9-5.368-6.976-8.956-12.67-8.956s-10.77 3.588-12.67 8.956"
            transform="translate(-639.000000, -132.000000) translate(642.000000, 135.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "01_general-04": (
    <svg xmlns="http://www.w3.org/2000/svg" width="110" height="90" viewBox="0 0 110 90">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M27.65 57.65c-.043 9.445 3.687 18.516 10.36 25.2M27.65 57.65H17.28c-9.55 0-17.28-8-17.28-18s7.73-18 17.28-18h10.37v36z"
            transform="translate(-1186.000000, -145.000000) translate(1189.000000, 149.000000)"
          />
          <path
            stroke="#522181"
            d="M27.65 57.65c20.392.042 40.282 6.323 57 18l5.22 3.55V0l-5.24 3.65c-16.715 11.682-36.607 17.963-57 18l.02 36z"
            transform="translate(-1186.000000, -145.000000) translate(1189.000000, 149.000000)"
          />
          <path
            stroke="#8451EC"
            d="M103.68 32.4L103.68 46.8"
            transform="translate(-1186.000000, -145.000000) translate(1189.000000, 149.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "01_general-05": (
    <svg viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M108 86.4v14.4c0 3.976-3.224 7.2-7.2 7.2H86.39M86.39 0h14.4c3.976 0 7.2 3.224 7.2 7.2v14.4M0 21.6V7.2C0 3.227 3.217.006 7.19 0h14.4M21.59 108H7.19c-3.973-.006-7.19-3.227-7.19-7.2V86.4"
            transform="translate(-899.000000, -133.000000) translate(902.000000, 136.000000)"
          />
          <path
            stroke="#8451EC"
            d="M54 59.42c10.935 0 19.8-8.865 19.8-19.8s-8.865-19.8-19.8-19.8-19.8 8.865-19.8 19.8c-.003 5.252 2.083 10.29 5.796 14.004C43.71 57.337 48.748 59.423 54 59.42h0zM84.55 88.18c-4.58-12.947-16.822-21.603-30.555-21.603S28.019 75.233 23.44 88.18"
            transform="translate(-899.000000, -133.000000) translate(902.000000, 136.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "01_general-08": (
    <svg viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M50.4 108h-36C6.447 108 0 101.553 0 93.6V14.44c-.01-3.826 1.502-7.499 4.204-10.208C6.905 1.522 10.574 0 14.4 0h36c3.826 0 7.495 1.523 10.197 4.232C63.298 6.94 64.81 10.614 64.8 14.44v10.8M0 86.44L28.8 86.44"
            transform="translate(-2009.000000, -133.000000) translate(2012.000000, 136.000000)"
          />
          <path
            stroke="#8451EC"
            d="M107.46 73.93L95.7 62.19c-4.976-4.978-12.821-5.63-18.55-1.54l-7.89 5.64-10.17-10.18c-1.786-1.967-4.51-2.79-7.087-2.143-2.576.648-4.587 2.663-5.23 5.24-.643 2.578.186 5.3 2.157 7.083l17.82 17.82-6 2c-3.82 1.268-6.066 5.218-5.2 9.149.865 3.931 4.56 6.574 8.56 6.121l17.9-2"
            transform="translate(-2009.000000, -133.000000) translate(2012.000000, 136.000000)"
          />
          <path
            stroke="#8451EC"
            d="M39.62 76.34c-7.876-4.528-12.076-13.5-10.51-22.45 1.566-8.948 8.564-15.96 17.51-17.544 8.945-1.585 17.926 2.598 22.47 10.464"
            transform="translate(-2009.000000, -133.000000) translate(2012.000000, 136.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "01_general-10": (
    <svg viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M72 57.6c0-3.976 3.224-7.2 7.2-7.2h21.6c3.976 0 7.2 3.224 7.2 7.2v43.2c0 3.976-3.224 7.2-7.2 7.2H79.2c-3.976 0-7.2-3.224-7.2-7.2V57.6zM72 93.6L108 93.6"
            transform="translate(-2503.000000, -133.000000) translate(2506.000000, 136.000000)"
          />
          <path
            stroke="#8451EC"
            d="M14.4 72c-.003 7.639 3.03 14.966 8.432 20.368 5.402 5.401 12.729 8.435 20.368 8.432H54M108 36c0-7.638-3.034-14.964-8.435-20.365C94.164 10.235 86.838 7.2 79.2 7.2H72"
            transform="translate(-2503.000000, -133.000000) translate(2506.000000, 136.000000)"
          />
          <path
            stroke="#8451EC"
            d="M79.2 0L72 7.2 79.2 14.4M46.8 108L54 100.8 46.8 93.6"
            transform="translate(-2503.000000, -133.000000) translate(2506.000000, 136.000000)"
          />
          <path
            stroke="#522181"
            d="M46.8 0L36 36 7.2 36 0 14.4 42.48 14.4M9 46.8c.994 0 1.8.806 1.8 1.8s-.806 1.8-1.8 1.8-1.8-.806-1.8-1.8c.005-.992.808-1.795 1.8-1.8M34.2 46.8c.994 0 1.8.806 1.8 1.8s-.806 1.8-1.8 1.8-1.8-.806-1.8-1.8c.005-.992.808-1.795 1.8-1.8"
            transform="translate(-2503.000000, -133.000000) translate(2506.000000, 136.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "01_general-31": (
    <svg width="112" height="112" viewBox="0 0 112 112">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M0 21.16c0-1.865.744-3.653 2.068-4.968 1.323-1.314 3.117-2.045 4.982-2.032H98.7c1.865 0 3.653.744 4.968 2.068 1.314 1.323 2.045 3.117 2.032 4.982v77.55c-.027 3.855-3.145 6.973-7 7H7.05c-3.866 0-7-3.134-7-7L0 21.16zM0 42.31L105.75 42.31M28.2 24.68L28.2 0M77.55 24.68L77.55 0"
            transform="translate(-111.000000, -784.000000) translate(114.000000, 787.000000)"
          />
          <path
            stroke="#8451EC"
            d="M22.87 59.93c-.718-.004-1.367.426-1.643 1.088-.277.662-.126 1.426.381 1.934.508.507 1.272.658 1.934.381.662-.276 1.092-.925 1.088-1.643 0-.972-.788-1.76-1.76-1.76M22.87 84.61c-.972 0-1.76.788-1.76 1.76s.788 1.76 1.76 1.76 1.76-.788 1.76-1.76c0-.467-.185-.914-.515-1.245-.33-.33-.778-.515-1.245-.515M52.87 59.93c-.718-.004-1.367.426-1.643 1.088-.277.662-.126 1.426.381 1.934.508.507 1.272.658 1.934.381.662-.276 1.092-.925 1.088-1.643 0-.467-.185-.914-.515-1.245-.33-.33-.778-.515-1.245-.515M52.87 84.61c-.972 0-1.76.788-1.76 1.76s.788 1.76 1.76 1.76 1.76-.788 1.76-1.76c0-.467-.185-.914-.515-1.245-.33-.33-.778-.515-1.245-.515M82.87 59.93c-.717 0-1.363.432-1.636 1.095-.274.663-.12 1.425.388 1.93.508.506 1.271.654 1.932.377s1.09-.925 1.086-1.642c0-.469-.187-.918-.519-1.248-.332-.33-.782-.515-1.251-.512M82.87 84.61c-.97.006-1.754.796-1.75 1.767.004.97.793 1.755 1.763 1.753.971-.002 1.757-.79 1.757-1.76 0-.469-.187-.918-.519-1.248-.332-.33-.782-.515-1.251-.512"
            transform="translate(-111.000000, -784.000000) translate(114.000000, 787.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "02_business-07": (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="114" viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M10.8 21.6c4.373 0 8.314-2.637 9.983-6.678 1.668-4.042.735-8.691-2.364-11.776C15.319.06 10.666-.851 6.632.836 2.598 2.525-.02 6.479 0 10.85.028 16.795 4.855 21.6 10.8 21.6zM19.55 17.14L28.8 23.85M10.8 108c5.965 0 10.8-4.835 10.8-10.8 0-5.964-4.835-10.8-10.8-10.8C4.835 86.4 0 91.236 0 97.2c0 5.965 4.835 10.8 10.8 10.8zM19.55 90.85L28.8 84.13M97.2 21.6c4.373 0 8.314-2.637 9.983-6.678 1.668-4.042.735-8.691-2.364-11.776-3.1-3.085-7.753-3.997-11.787-2.31C88.998 2.525 86.38 6.479 86.4 10.85c.028 5.945 4.855 10.75 10.8 10.75h0zM88.45 17.14L79.2 23.85M97.2 108c5.965 0 10.8-4.835 10.8-10.8 0-5.964-4.835-10.8-10.8-10.8-5.965 0-10.8 4.836-10.8 10.8 0 5.965 4.835 10.8 10.8 10.8h0zM88.45 90.85L79.2 84.13"
            transform="translate(-2503.000000, -783.000000) translate(2506.000000, 786.000000)"
          />
          <path
            stroke="#8451EC"
            d="M43.2 64.85c0 4.369 2.631 8.307 6.667 9.978 4.036 1.672 8.681.748 11.77-2.34 3.089-3.09 4.013-7.735 2.341-11.77-1.672-4.036-5.61-6.668-9.978-6.668-5.965 0-10.8-4.835-10.8-10.8 0-5.964 4.835-10.8 10.8-10.8 5.965 0 10.8 4.836 10.8 10.8M54 25.2L54 32.4M54 75.6L54 82.85"
            transform="translate(-2503.000000, -783.000000) translate(2506.000000, 786.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "02_business-14": (
    <svg xmlns="http://www.w3.org/2000/svg" width="115" height="114" viewBox="0 0 115 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M47.032 8.084c1.784 1.986 4.33 3.121 7 3.121s5.215-1.135 7-3.121l4.51-5C68.209.144 72.437-.803 76.104.717c3.667 1.521 5.983 5.182 5.788 9.147l-.34 6.72c-.137 2.658.86 5.25 2.74 7.132 1.881 1.883 4.472 2.881 7.13 2.748l6.72-.35c3.967-.19 7.626 2.133 9.144 5.803 1.518 3.67.568 7.899-2.374 10.567l-5 4.52c-1.987 1.785-3.122 4.33-3.122 7s1.135 5.215 3.122 7l5 4.51c2.956 2.664 3.914 6.902 2.391 10.58-1.523 3.677-5.197 5.996-9.171 5.79l-6.72-.34c-2.658-.136-5.25.86-7.133 2.74-1.883 1.881-2.88 4.472-2.747 7.13l.35 6.72c.184 3.963-2.137 7.615-5.802 9.132-3.666 1.517-7.889.572-10.558-2.362l-4.51-5c-1.785-1.987-4.33-3.121-7-3.121s-5.216 1.134-7 3.12l-4.51 5c-2.666 2.937-6.887 3.885-10.552 2.37-3.665-1.515-5.985-5.168-5.798-9.13l.35-6.72c.14-2.664-.859-5.262-2.747-7.147-1.889-1.884-4.49-2.878-7.153-2.732l-6.72.34c-3.985.204-7.665-2.13-9.179-5.821-1.514-3.692-.532-7.937 2.449-10.59l5-4.51c1.986-1.784 3.12-4.329 3.12-7 0-2.67-1.134-5.214-3.12-7l-5-4.52C.223 39.778-.72 35.562.795 31.902c1.514-3.66 5.16-5.979 9.117-5.797l6.72.34c2.662.14 5.259-.857 7.143-2.744 1.885-1.886 2.88-4.484 2.737-7.146l-.32-6.73c-.169-3.954 2.157-7.59 5.818-9.095 3.66-1.504 7.87-.555 10.532 2.375l4.49 4.98z"
            transform="translate(-1713.000000, -1031.000000) translate(1716.000000, 1034.000000)"
          />
          <path
            stroke="#8451EC"
            d="M63.032 39.584h-12.6c-3.052.04-5.655 2.218-6.236 5.214-.58 2.995 1.02 5.988 3.836 7.166l12.74 4c2.868 1.146 4.519 4.169 3.932 7.202-.586 3.033-3.243 5.223-6.332 5.218h-15.14M54.032 39.584L54.032 32.384M54.032 75.584L54.032 68.384"
            transform="translate(-1713.000000, -1031.000000) translate(1716.000000, 1034.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "02_business-26": (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="114" viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M10.8 21.6c5.965 0 10.8-4.835 10.8-10.8C21.6 4.835 16.765 0 10.8 0 4.835 0 0 4.835 0 10.8c.006 5.962 4.838 10.794 10.8 10.8zM19.54 17.14L28.8 23.85M10.8 108c5.965 0 10.8-4.835 10.8-10.8 0-5.965-4.835-10.8-10.8-10.8C4.835 86.4 0 91.235 0 97.2c.006 5.962 4.838 10.794 10.8 10.8h0zM19.54 90.86L28.8 84.14M97.2 21.6c5.965 0 10.8-4.835 10.8-10.8C108 4.835 103.165 0 97.2 0c-5.965 0-10.8 4.835-10.8 10.8.006 5.962 4.838 10.794 10.8 10.8zM88.45 17.14L79.2 23.85M97.2 108c5.965 0 10.8-4.835 10.8-10.8 0-5.965-4.835-10.8-10.8-10.8-5.965 0-10.8 4.835-10.8 10.8.006 5.962 4.838 10.794 10.8 10.8h0zM88.45 90.86L79.2 84.14"
            transform="translate(-2272.000000, -1258.000000) translate(2275.000000, 1261.000000)"
          />
          <path
            stroke="#8451EC"
            d="M54 46.8c5.096 0 9.69-3.07 11.64-7.778 1.951-4.708.873-10.128-2.73-13.732-3.604-3.603-9.024-4.681-13.732-2.73C44.47 24.51 41.4 29.103 41.4 34.2c0 6.959 5.641 12.6 12.6 12.6h0zM32.4 72c0-7.717 4.117-14.848 10.8-18.706 6.683-3.859 14.917-3.859 21.6 0C71.483 57.152 75.6 64.284 75.6 72H32.4z"
            transform="translate(-2272.000000, -1258.000000) translate(2275.000000, 1261.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "02_business-33": (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="114" viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#8451EC"
            d="M21.36 68.4H29l14.68 11.16c1.425 1.602 3.86 1.797 5.52.44l20.44-16.89c1.703-1.379 1.98-3.871.62-5.59L59 45M47.93 34.32l-1.18-1c-2.392-1.759-5.522-2.16-8.28-1.06L21.33 39.6"
            transform="translate(-1442.000000, -1506.000000) translate(1445.000000, 1509.000000)"
          />
          <path
            stroke="#522181"
            d="M67.6 27.69L89.87 36.47M65.7 42.15l-10.85 4.58c-1.727.717-3.673.692-5.38-.07-1.733-.78-3.083-2.22-3.75-4-1.351-3.46.107-7.383 3.39-9.12"
            transform="translate(-1442.000000, -1506.000000) translate(1445.000000, 1509.000000)"
          />
          <path
            stroke="#8451EC"
            d="M3.07 72h12.77c3.01.16 5.583-2.142 5.76-5.15V41.14c-.177-3.007-2.752-5.305-5.76-5.14H3.07"
            transform="translate(-1442.000000, -1506.000000) translate(1445.000000, 1509.000000)"
          />
          <path
            stroke="#522181"
            d="M104.93 72H92.16c-3.01.16-5.583-2.142-5.76-5.15V41.14c.177-3.007 2.752-5.305 5.76-5.14M86.4 63.62L63.4 68.21M49.11 33.55L60 28.14c2.37-1.229 5.152-1.392 7.65-.45M92.16 36L104.93 36"
            transform="translate(-1442.000000, -1506.000000) translate(1445.000000, 1509.000000)"
          />
          <path
            stroke="#522181"
            d="M54 108c29.823 0 54-24.177 54-54S83.823 0 54 0 0 24.177 0 54s24.177 54 54 54z"
            transform="translate(-1442.000000, -1506.000000) translate(1445.000000, 1509.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "02_business-38": (
    <svg xmlns="http://www.w3.org/2000/svg" width="115" height="89" viewBox="0 0 115 89">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#8451EC"
            d="M13.8 68.95L0 68.95M10.35 82.75L10.35 68.95M94.89 68.95L108.69 68.95M98.34 82.75L98.34 68.95M37.95 48.25L86.25 48.25"
            transform="translate(-111.000000, -1707.000000) translate(114.000000, 1710.000000)"
          />
          <path
            stroke="#522181"
            d="M13.8 20.7c5.707-.011 10.328-4.64 10.33-10.347C24.132 4.646 19.514.015 13.807 0 8.1-.015 3.457 4.593 3.43 10.3c-.013 2.757 1.074 5.406 3.02 7.358 1.948 1.952 4.593 3.047 7.35 3.042h0zM37.96 82.75c-2.617.009-5.012-1.468-6.18-3.81l-3.09-6.17c-1.156-2.34-3.54-3.82-6.15-3.82H13.8c-3.81 0-6.9-3.09-6.9-6.9v-27.6c-.004-2.547 1.396-4.89 3.64-6.092 2.246-1.203 4.971-1.072 7.09.342l5.13 3.43c2.276 1.502 4.943 2.302 7.67 2.3h7.53c3.81 0 6.9 3.09 6.9 6.9 0 3.81-3.09 6.9-6.9 6.9h-7.53c-3.318.01-6.611-.58-9.72-1.74v8.66h1.84c7.844-.02 15.02 4.415 18.51 11.44l3.08 6.18c1.083 2.141.974 4.691-.287 6.732-1.261 2.041-3.494 3.28-5.893 3.268v-.02z"
            transform="translate(-111.000000, -1707.000000) translate(114.000000, 1710.000000)"
          />
          <path
            stroke="#8451EC"
            d="M54.43 48.25L54.43 82.75"
            transform="translate(-111.000000, -1707.000000) translate(114.000000, 1710.000000)"
          />
          <path
            stroke="#522181"
            d="M94.89 20.7c-5.71 0-10.34-4.624-10.35-10.333C84.531 4.657 89.147.018 94.857 0c5.71-.018 10.355 4.59 10.383 10.3.013 2.754-1.071 5.4-3.014 7.35-1.942 1.953-4.582 3.05-7.336 3.05h0zM70.73 82.75c2.617.009 5.012-1.468 6.18-3.81L80 72.77c1.156-2.34 3.54-3.82 6.15-3.82h8.74c3.81 0 6.9-3.09 6.9-6.9v-27.6c.004-2.547-1.396-4.89-3.64-6.092-2.246-1.203-4.971-1.072-7.09.342l-5.13 3.43c-2.272 1.502-4.936 2.302-7.66 2.3h-7.53c-3.81 0-6.9 3.09-6.9 6.9 0 3.81 3.09 6.9 6.9 6.9h7.53c3.318.01 6.611-.58 9.72-1.74v8.66h-1.84c-7.848-.024-15.028 4.412-18.52 11.44l-3.08 6.18c-1.083 2.141-.974 4.691.287 6.732 1.261 2.041 3.494 3.28 5.893 3.268v-.02z"
            transform="translate(-111.000000, -1707.000000) translate(114.000000, 1710.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "02_business-41": (
    <svg xmlns="http://www.w3.org/2000/svg" width="98" height="105" viewBox="0 0 98 105">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M6.95 14.12L0 14.12M6.95 42.36L0 42.36M6.95 56.48L0 56.48M6.95 70.6L0 70.6M6.95 84.72L0 84.72M6.95 28.24L0 28.24M31.55 50.14L31.55 65.91M82.07 0c5.22 0 9.46 3.24 9.46 7.24V91.6c0 4-4.24 7.24-9.46 7.24h-64.2c-5.23 0-9.47-3.24-9.47-7.24V7.24c0-4 4.24-7.24 9.47-7.24h64.2z"
            transform="translate(-639.000000, -1707.000000) translate(642.000000, 1710.000000)"
          />
          <path
            stroke="#522181"
            d="M31.55 85.66c5.203 0 9.42-4.217 9.42-9.42s-4.217-9.42-9.42-9.42-9.42 4.217-9.42 9.42c.006 5.2 4.22 9.414 9.42 9.42h0zM31.79 50.14L68.16 50.14M68.22 49.49L68.22 16.53"
            transform="translate(-639.000000, -1707.000000) translate(642.000000, 1710.000000)"
          />
          <path
            stroke="#8451EC"
            d="M25.61 16.16L42.9 33.46M42.9 16.16L25.61 33.46M57.41 66.82L74.71 84.11M74.71 66.82L57.41 84.11"
            transform="translate(-639.000000, -1707.000000) translate(642.000000, 1710.000000)"
          />
          <path
            stroke="#522181"
            d="M68.22 14.18L78.22 23.27M67.9 14.18L57.9 23.27"
            transform="translate(-639.000000, -1707.000000) translate(642.000000, 1710.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "03_charts-07": (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="114" viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#8451EC"
            d="M100.8 0L65.52 35.28c-2.489 2.492-6.415 2.817-9.28.77L40.43 24.76c-2.621-1.87-6.166-1.772-8.68.24L0 50.4"
            transform="translate(-2503.000000, -1707.000000) translate(2506.000000, 1710.000000)"
          />
          <path
            stroke="#8451EC"
            d="M72 0L100.8 0 100.8 28.8"
            transform="translate(-2503.000000, -1707.000000) translate(2506.000000, 1710.000000)"
          />
          <path
            stroke="#522181"
            d="M64.8 97.2c0-1.988 1.612-3.6 3.6-3.6h36c1.988 0 3.6 1.612 3.6 3.6v7.2c0 1.988-1.612 3.6-3.6 3.6h-36c-1.988 0-3.6-1.612-3.6-3.6v-7.2zM7.2 97.2c0-1.988 1.612-3.6 3.6-3.6h36c1.988 0 3.6 1.612 3.6 3.6v7.2c0 1.988-1.612 3.6-3.6 3.6h-36c-1.988 0-3.6-1.612-3.6-3.6v-7.2zM0 82.8c0-1.988 1.612-3.6 3.6-3.6h36c1.988 0 3.6 1.612 3.6 3.6V90c0 1.988-1.612 3.6-3.6 3.6h-36c-.955 0-1.87-.38-2.546-1.054C.38 91.87 0 90.955 0 90v-7.2zM7.2 68.4c0-1.988 1.612-3.6 3.6-3.6h36c1.988 0 3.6 1.612 3.6 3.6v7.2c0 1.988-1.612 3.6-3.6 3.6h-36c-1.988 0-3.6-1.612-3.6-3.6v-7.2zM57.6 82.8c0-1.988 1.612-3.6 3.6-3.6h36c1.988 0 3.6 1.612 3.6 3.6V90c0 1.988-1.612 3.6-3.6 3.6h-36c-.955 0-1.87-.38-2.546-1.054C57.98 91.87 57.6 90.955 57.6 90v-7.2zM64.8 68.4c0-1.988 1.612-3.6 3.6-3.6h36c1.988 0 3.6 1.612 3.6 3.6v7.2c0 1.988-1.612 3.6-3.6 3.6h-36c-1.988 0-3.6-1.612-3.6-3.6v-7.2zM64.8 54c0-1.988 1.612-3.6 3.6-3.6h36c1.988 0 3.6 1.612 3.6 3.6v7.2c0 1.988-1.612 3.6-3.6 3.6h-36c-1.988 0-3.6-1.612-3.6-3.6V54z"
            transform="translate(-2503.000000, -1707.000000) translate(2506.000000, 1710.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "03_charts-11": (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="115" viewBox="0 0 114 115">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M107.96 97.14l-7.16-10.73v-25.2c0-9.6-18.24-19.87-25.2-25.2M84.87 67.42l-17.51-14c-2.461-2.337-6.337-2.287-8.737.113-2.4 2.4-2.45 6.276-.113 8.737l17 19.14v12c0 5.66 8.1 14.61 8.1 14.61"
            transform="translate(-899.000000, -1918.000000) translate(902.000000, 1921.000000)"
          />
          <path
            stroke="#522181"
            d="M61.2 100.81H6.6c-3.643-.005-6.594-2.957-6.6-6.6V6.6C0 2.955 2.955 0 6.6 0H69c1.75-.003 3.428.69 4.666 1.927C74.904 3.163 75.6 4.84 75.6 6.59V60"
            transform="translate(-899.000000, -1918.000000) translate(902.000000, 1921.000000)"
          />
          <path
            stroke="#8451EC"
            d="M43.2 14.41L57.6 14.41 57.6 28.81M57.6 14.41L14.4 54M21.56 72L21.56 86.4M35.96 61.21L35.96 86.41"
            transform="translate(-899.000000, -1918.000000) translate(902.000000, 1921.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "03_charts-13": (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="115" viewBox="0 0 100 115">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M21.64 50.4v50.32c.006 1.926-.951 3.727-2.55 4.8h0c-4.996 3.331-11.504 3.331-16.5 0h0c-1.599-1.073-2.556-2.874-2.55-4.8V50.4"
            transform="translate(-1442.000000, -1918.000000) translate(1445.000000, 1921.000000)"
          />
          <path
            stroke="#522181"
            d="M10.8 57.6c6 0 10.8-3.23 10.8-7.2s-4.84-7.2-10.8-7.2C4.84 43.2 0 46.42 0 50.4s4.84 7.2 10.8 7.2zM57.64 28.8v71.92c.006 1.926-.951 3.727-2.55 4.8h0c-4.996 3.331-11.504 3.331-16.5 0h0c-1.599-1.073-2.556-2.874-2.55-4.8V28.8"
            transform="translate(-1442.000000, -1918.000000) translate(1445.000000, 1921.000000)"
          />
          <path
            stroke="#522181"
            d="M46.8 36c6 0 10.8-3.23 10.8-7.2s-4.84-7.2-10.8-7.2c-5.96 0-10.8 3.22-10.8 7.2S40.84 36 46.8 36z"
            transform="translate(-1442.000000, -1918.000000) translate(1445.000000, 1921.000000)"
          />
          <path
            stroke="#8451EC"
            d="M93.64 7.2v93.52c.006 1.926-.951 3.727-2.55 4.8h0c-4.996 3.331-11.504 3.331-16.5 0h0c-1.599-1.073-2.556-2.874-2.55-4.8V7.2"
            transform="translate(-1442.000000, -1918.000000) translate(1445.000000, 1921.000000)"
          />
          <path
            stroke="#8451EC"
            d="M82.8 14.4c6 0 10.8-3.23 10.8-7.2S88.76 0 82.8 0C76.84 0 72 3.22 72 7.2s4.84 7.2 10.8 7.2z"
            transform="translate(-1442.000000, -1918.000000) translate(1445.000000, 1921.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "03_charts-23": (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="114" viewBox="0 0 114 114">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#8451EC"
            d="M72.9 37.56L94.46 10.61M42.58 31.73L61.82 40.27M0 50.39L29.83 32.49"
            transform="translate(-1442.000000, -2141.000000) translate(1445.000000, 2144.000000)"
          />
          <path
            stroke="#522181"
            d="M71.09 75.71L93.84 63.07M36 79.2L57.6 79.2M0 93.59L22.36 82.41"
            transform="translate(-1442.000000, -2141.000000) translate(1445.000000, 2144.000000)"
          />
          <path
            stroke="#8451EC"
            d="M36 36c3.976 0 7.2-3.224 7.2-7.2s-3.224-7.2-7.2-7.2-7.2 3.224-7.2 7.2c0 1.91.759 3.74 2.109 5.091C32.259 35.241 34.09 36 36 36h0zM68.4 50.4c3.976 0 7.2-3.224 7.2-7.2S72.376 36 68.4 36s-7.2 3.224-7.2 7.2c0 1.91.759 3.74 2.109 5.091 1.35 1.35 3.181 2.109 5.091 2.109h0zM100.8 14.4c3.976 0 7.2-3.224 7.2-7.2S104.776 0 100.8 0s-7.2 3.224-7.2 7.2 3.224 7.2 7.2 7.2h0z"
            transform="translate(-1442.000000, -2141.000000) translate(1445.000000, 2144.000000)"
          />
          <path
            stroke="#522181"
            d="M100.8 68.4c3.976 0 7.2-3.224 7.2-7.2s-3.224-7.2-7.2-7.2-7.2 3.224-7.2 7.2 3.224 7.2 7.2 7.2h0zM64.8 86.4c3.976 0 7.2-3.224 7.2-7.2S68.776 72 64.8 72s-7.2 3.224-7.2 7.2c0 1.91.759 3.74 2.109 5.091 1.35 1.35 3.181 2.109 5.091 2.109h0zM28.8 86.4c3.976 0 7.2-3.224 7.2-7.2S32.776 72 28.8 72s-7.2 3.224-7.2 7.2 3.224 7.2 7.2 7.2z"
            transform="translate(-1442.000000, -2141.000000) translate(1445.000000, 2144.000000)"
          />
          <path
            stroke="#522181"
            d="M0 0L0 108 108 108"
            transform="translate(-1442.000000, -2141.000000) translate(1445.000000, 2144.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "05_food-and-drink-42": (
    <svg xmlns="http://www.w3.org/2000/svg" width="105" height="113" viewBox="0 0 105 113">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#8451EC"
            d="M19.76 24.52L50.91 34.04M26.96 39.16c.43.144.789.449 1 .85.318.56.308 1.247-.027 1.796-.335.55-.94.874-1.584.848-.642-.026-1.22-.4-1.509-.974-.217-.409-.263-.887-.13-1.33.289-.933 1.272-1.463 2.21-1.19M65.73 39.16c.433.144.792.453 1 .86.334.632.255 1.402-.2 1.953-.455.551-1.196.775-1.88.567-.446-.134-.82-.44-1.038-.852-.218-.412-.262-.894-.122-1.338.284-.932 1.265-1.462 2.2-1.19M76.36 49.74c.432.141.791.446 1 .85.323.632.24 1.396-.212 1.943-.452.548-1.186.775-1.868.577-.448-.131-.824-.438-1.042-.85-.218-.413-.26-.896-.118-1.34.136-.457.45-.84.872-1.061.421-.222.915-.265 1.368-.119M69.26 60.31c.433.144.792.453 1 .86.323.632.24 1.396-.212 1.943-.452.548-1.186.775-1.868.577-.433-.144-.792-.453-1-.86-.219-.409-.262-.889-.12-1.33.28-.935 1.264-1.468 2.2-1.19M34.01 49.74c.432.141.791.446 1 .85.323.632.24 1.396-.212 1.943-.452.548-1.186.775-1.868.577-.448-.131-.824-.438-1.042-.85-.218-.413-.26-.896-.118-1.34.284-.931 1.267-1.459 2.2-1.18M23.43 60.31c.433.144.792.453 1 .86.33.63.252 1.397-.2 1.947-.45.55-1.188.775-1.87.573-.446-.134-.82-.44-1.038-.852-.218-.412-.262-.894-.122-1.338.284-.932 1.265-1.462 2.2-1.19M67.36 28.37L79.92 24.61"
            transform="translate(-2503.000000, -3974.000000) translate(2506.000000, 3977.000000)"
          />
          <path
            stroke="#522181"
            d="M0 97.93L26 105.85M12.98 101.9L20.91 75.9M32.19 75.91h0c-7.388 2.312-15.437-.141-20.28-6.18h0c-4.548-5.696-5.561-13.446-2.63-20.12L29.09 2.14c.655-1.632 2.444-2.498 4.13-2l20.14 6.14c1.694.53 2.702 2.267 2.32 4l-10 50.44c-1.319 7.18-6.517 13.032-13.49 15.19zM72.94 106.04L98.94 98.25M85.94 102.18L78.13 76.12M63.86 1.04l2.7-.81c1.683-.492 3.465.373 4.12 2l19.58 47.54c2.9 6.685 1.852 14.427-2.72 20.1h0c-4.872 6.023-12.935 8.447-20.32 6.11h0c-4.562-1.458-8.428-4.544-10.86-8.67"
            transform="translate(-2503.000000, -3974.000000) translate(2506.000000, 3977.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "06_platforms-and-KPM-18": (
    <svg xmlns="http://www.w3.org/2000/svg" width="116" height="116" viewBox="0 0 116 116">
      <g fill="none" fillRule="evenodd">
        <g>
          <path
            fill="#522181"
            fillRule="nonzero"
            d="M46 52.59v-1h-1.8v6.1h1.85v-3.33c.244-.693.916-1.142 1.65-1.1.214-.005.429.012.64.05v-1.76c-.189-.053-.384-.076-.58-.07-.732.062-1.389.476-1.76 1.11zM54.25 56.89c1.2-1.256 1.2-3.234 0-4.49-.587-.61-1.404-.945-2.25-.92-.832-.013-1.633.32-2.21.92-1.2 1.256-1.2 3.234 0 4.49.57.61 1.375.946 2.21.92.846.025 1.663-.31 2.25-.92zm-3.19-1.19c-.494-.61-.494-1.48 0-2.09.247-.292.618-.452 1-.43.382-.02.752.139 1 .43.248.274.387.63.39 1 .005.41-.157.803-.45 1.09-.251.287-.619.445-1 .43-.36-.001-.703-.158-.94-.43zM65.94 51.5c-.818-.022-1.607.305-2.17.9-1.17 1.283-1.17 3.247 0 4.53.589.59 1.397.91 2.23.88.547.015 1.09-.105 1.58-.35.457-.263.866-.601 1.21-1l-1.34-.74c-.377.318-.857.485-1.35.47-.68.09-1.307-.382-1.41-1.06h4.2c-.008-.05-.008-.1 0-.15.009-.06.009-.12 0-.18v-.14c.023-.84-.27-1.656-.82-2.29-.553-.58-1.328-.897-2.13-.87zm-1.25 2.58c.065-.308.23-.586.47-.79.216-.172.484-.267.76-.27.28-.004.547.108.74.31.21.2.346.464.39.75h-2.36zM73.19 51.5c-.722.061-1.367.477-1.72 1.11v-1h-1.8v6.1h1.86v-3.35c.252-.66.895-1.085 1.6-1.06.225 0 .449.02.67.06v-1.79c-.2-.051-.404-.075-.61-.07z"
            transform="translate(-898.000000, -4618.000000) translate(902.000000, 4622.000000)"
          />
          <path
            fill="#522181"
            fillRule="nonzero"
            d="M42.44 50.46c.017-.21.017-.42 0-.63 0-2.386 1.934-4.32 4.32-4.32s4.32 1.934 4.32 4.32h1.74c.025-3.352-2.673-6.09-6.025-6.115-3.352-.025-6.09 2.673-6.115 6.025.014.166.014.334 0 .5-.101.833-.45 1.617-1 2.25-.547.603-1.272 1.016-2.07 1.18v-4.05h-2v8.11h2v-2.3c.573-.097 1.131-.269 1.66-.51l1.76 2.77h2.35l-2.55-3.85.2-.19c.78-.898 1.271-2.01 1.41-3.19zM62.09 59.49v-7.88h-1.76v.51c-.417-.425-.996-.65-1.59-.62-.76.002-1.485.321-2 .88-.573.582-.883 1.373-.86 2.19-.02.814.299 1.6.88 2.17.521.548 1.244.858 2 .86.578.007 1.142-.172 1.61-.51v2.4c.071 1.373-.62 2.674-1.8 3.382-1.178.708-2.652.708-3.83 0-1.18-.708-1.871-2.009-1.8-3.382h-1.76c.075 2.93 2.448 5.277 5.378 5.32 2.93.043 5.371-2.234 5.532-5.16v-.16zM60 55.6c-.257.276-.623.426-1 .41-.378.022-.746-.129-1-.41-.494-.601-.494-1.469 0-2.07.259-.274.623-.424 1-.41.378-.018.744.132 1 .41.244.275.376.632.37 1 .037.393-.098.783-.37 1.07zM63.46 62.36c0 .177-.07.346-.197.47-.126.124-.296.193-.473.19-.176.003-.345-.066-.47-.19-.124-.125-.193-.294-.19-.47-.003-.175.066-.344.19-.466.126-.123.295-.19.47-.184.362 0 .66.288.67.65zm-1.18 0c-.003.138.05.271.145.37.096.1.227.157.365.16.133-.003.259-.058.35-.153.093-.096.143-.224.14-.357.008-.14-.042-.276-.139-.377-.097-.1-.231-.156-.371-.153-.134-.003-.264.05-.357.147-.093.097-.141.229-.133.363zm.39.33h-.15v-.65h.25c.08-.014.16-.014.24 0 .042.034.065.086.06.14 0 .08-.06.12-.14.16.062.028.107.084.12.15.003.053.003.107 0 .16h-.15c-.03-.049-.05-.103-.06-.16 0-.07-.06-.09-.14-.09h-.08v.27l.05.02zm0-.37h.08c.08 0 .16 0 .16-.1s0-.1-.14-.1h-.08v.2h-.02z"
            transform="translate(-898.000000, -4618.000000) translate(902.000000, 4622.000000)"
          />
          <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="6.17">
            <g>
              <path
                stroke="#8451EC"
                d="M54.34 79.73L54.34 108.73M54.34 0L54.34 29M29 54.36L0 54.36M108.71 54.36L79.71 54.36"
                transform="translate(-898.000000, -4618.000000) translate(902.000000, 4622.000000)"
              />
              <path
                stroke="#522181"
                d="M54.34 94.22c22.014 0 39.86-17.846 39.86-39.86S76.354 14.5 54.34 14.5 14.48 32.346 14.48 54.36s17.846 39.86 39.86 39.86z"
                transform="translate(-898.000000, -4618.000000) translate(902.000000, 4622.000000)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  "07_tech-and-devices-15": (
    <svg xmlns="http://www.w3.org/2000/svg" width="112" height="113" viewBox="0 0 112 113">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M105.743 53.318c.003-6.308-4.189-11.848-10.26-13.56 2.974-2.89 3.984-7.252 2.584-11.157-1.4-3.904-4.951-6.63-9.084-6.973-.576-.633-1.228-1.194-1.94-1.67 3.022-7.046-.139-15.215-7.117-18.392-6.978-3.176-15.215-.194-18.543 6.712-1.996-2.692-5.149-4.28-8.5-4.28-3.352 0-6.505 1.588-8.5 4.28-3.226-7.097-11.593-10.235-18.69-7.01-7.097 3.226-10.236 11.593-7.01 18.69-.711.485-1.36 1.056-1.93 1.7-4.12.353-7.657 3.074-9.055 6.966-1.397 3.892-.4 8.24 2.555 11.134C4.187 41.478 0 47.018 0 53.323c0 6.306 4.187 11.845 10.253 13.565-2.976 2.889-3.988 7.25-2.588 11.154s4.954 6.628 9.088 6.966c.573.642 1.221 1.213 1.93 1.7-2.879 7.018.31 15.055 7.216 18.19 6.906 3.136 15.056.246 18.444-6.54 1.995 2.693 5.148 4.28 8.5 4.28 3.351 0 6.504-1.587 8.5-4.28 3.217 7.097 11.578 10.242 18.675 7.025 7.097-3.217 10.242-11.578 7.025-18.675.714-.484 1.366-1.055 1.94-1.7 4.133-.338 7.687-3.062 9.088-6.966 1.4-3.903.388-8.265-2.588-11.154 6.07-1.718 10.261-7.26 10.26-13.57z"
            transform="translate(-899.000000, -5227.000000) translate(902.000000, 5230.000000)"
          />
          <path
            stroke="#8451EC"
            d="M59.913 21.598l-27.77 32.36c-.442.525-.54 1.258-.254 1.88.287.624.908 1.025 1.594 1.03h12.37v28.2l27.74-32.37c.444-.522.544-1.255.257-1.878-.288-.623-.911-1.021-1.597-1.022h-12.34v-28.2z"
            transform="translate(-899.000000, -5227.000000) translate(902.000000, 5230.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "08_finance-06": (
    <svg xmlns="http://www.w3.org/2000/svg" width="112" height="98" viewBox="0 0 112 98">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M105.76 31.7c0 3.741-1.487 7.33-4.133 9.974-2.647 2.644-6.236 4.129-9.977 4.126"
            transform="translate(-2503.000000, -5635.000000) translate(2506.000000, 5638.000000)"
          />
          <path
            stroke="#8451EC"
            d="M35.26 24.65c8.882-4.4 19.308-4.4 28.19 0M26.44 38.75c-.718-.004-1.367.426-1.643 1.088-.277.662-.126 1.426.381 1.934.508.507 1.272.658 1.934.381.662-.276 1.092-.925 1.088-1.643 0-.972-.788-1.76-1.76-1.76"
            transform="translate(-2503.000000, -5635.000000) translate(2506.000000, 5638.000000)"
          />
          <path
            stroke="#522181"
            d="M33.61 10C28.09 0 14.1 0 14.1 0l3 20.6c-3.867 4.189-6.739 9.197-8.4 14.65H0v28.2h11.71c2.434 4.265 5.635 8.045 9.44 11.15v13.52c0 1.95 1.58 3.53 3.53 3.53h7.05c1.95 0 3.53-1.58 3.53-3.53v-5.87c9.15 3.045 19.04 3.045 28.19 0v5.78c0 1.95 1.58 3.53 3.53 3.53h7.05c.935 0 1.832-.372 2.493-1.035.66-.662 1.03-1.56 1.027-2.495V74.65c8.81-6.999 13.99-17.6 14.1-28.85 0-30.55-33.13-44.13-58.04-35.8z"
            transform="translate(-2503.000000, -5635.000000) translate(2506.000000, 5638.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "09_shopping-ecommerce-05": (
    <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M70.388 21.052L59.858 56.302 31.618 56.302 24.618 35.152 66.158 35.152M33.378 66.882c.972 0 1.76.788 1.76 1.76s-.788 1.76-1.76 1.76-1.76-.788-1.76-1.76.788-1.76 1.76-1.76M58.048 66.882c.712 0 1.354.428 1.626 1.086.273.658.122 1.415-.381 1.918-.504.503-1.26.654-1.918.382-.658-.273-1.087-.915-1.087-1.626 0-.972.788-1.76 1.76-1.76"
            transform="translate(-1186.000000, -6043.000000) translate(1189.000000, 6046.000000)"
          />
          <path
            stroke="#522181"
            d="M61.478 88.762c-20.02 7.314-42.44-.158-54.067-18.022-11.627-17.863-9.385-41.389 5.407-56.734C27.611-1.34 51.038-4.443 69.316 6.522c18.278 10.965 26.568 33.095 19.992 53.37"
            transform="translate(-1186.000000, -6043.000000) translate(1189.000000, 6046.000000)"
          />
          <path
            stroke="#8451EC"
            d="M73.238 73.242L85.698 105.652 93.178 93.192 105.638 85.712zM105.638 105.652L93.178 93.192"
            transform="translate(-1186.000000, -6043.000000) translate(1189.000000, 6046.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "10_content-06": (
    <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#522181"
            d="M0 14.1c0-3.866 3.134-7 7-7h91.66c3.866 0 7 3.134 7 7v84.61c-.027 3.855-3.145 6.973-7 7H7.04c-3.866 0-7-3.134-7-7L0 14.1zM21.14 0L21.14 14.1M84.6 0L84.6 14.1"
            transform="translate(-2009.000000, -6466.000000) translate(2012.000000, 6469.000000)"
          />
          <path
            stroke="#8451EC"
            d="M56.39 81.08L77.54 81.08M56.39 45.88L77.54 45.88M43 68.39L28.2 88.13 17.62 77.56M43 31.73L28.2 51.47 17.62 40.88"
            transform="translate(-2009.000000, -6466.000000) translate(2012.000000, 6469.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "10_content-08": (
    <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g strokeWidth="6">
          <path
            stroke="#8451EC"
            d="M52.87 0L52.87 7.05M17.62 35.28L25.17 35.28M88.12 35.28L80.56 35.28M23.79 12.22L30.21 18.63M81.94 12.22L75.53 18.63M70.49 35.28c.035-8.816-6.45-16.3-15.182-17.52-8.73-1.22-17.02 4.2-19.402 12.688-2.383 8.487 1.874 17.43 9.964 20.932v8.54h14.1v-8.54c6.39-2.805 10.517-9.122 10.52-16.1zM45.87 70.5L59.97 70.5"
            transform="translate(-2503.000000, -6466.000000) translate(2506.000000, 6469.000000)"
          />
          <path
            stroke="#522181"
            d="M85.87 88.12c4.993.008 9.499-2.993 11.415-7.604 1.916-4.61.865-9.921-2.662-13.455-3.528-3.533-8.837-4.592-13.45-2.684-4.614 1.91-7.623 6.41-7.623 11.403 0 6.807 5.513 12.329 12.32 12.34zM105.74 105.74c-2.919-8.473-10.893-14.16-19.855-14.16s-16.936 5.687-19.855 14.16M19.87 88.12c6.813-.011 12.327-5.54 12.32-12.353-.007-6.813-5.534-12.33-12.347-12.327-6.812.004-12.333 5.527-12.333 12.34-.003 3.277 1.3 6.42 3.618 8.736 2.32 2.315 5.465 3.612 8.742 3.604h0zM39.71 105.74c-2.919-8.473-10.893-14.16-19.855-14.16S2.919 97.267 0 105.74"
            transform="translate(-2503.000000, -6466.000000) translate(2506.000000, 6469.000000)"
          />
        </g>
      </g>
    </svg>
  ),
  "ad-agencies": (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#522181"
            d="M36.8 4.2c1.657 0 3 1.343 3 3 0 1.598-1.249 2.904-2.824 2.995l-.176.005H13.918c-2.684-.002-5.259 1.063-7.157 2.961-1.819 1.819-2.873 4.26-2.956 6.824l-.005.335v74.57c0 2.683 1.066 5.255 2.964 7.152 1.818 1.817 4.258 2.87 6.821 2.953l.335.005h31.362c2.683.002 5.256-1.062 7.154-2.958 1.819-1.818 2.874-4.256 2.958-6.817l.006-.335V61.2c0-1.657 1.343-3 3-3 1.598 0 2.904 1.249 2.995 2.824l.005.176v33.69c0 4.275-1.699 8.374-4.723 11.396-2.926 2.924-6.861 4.606-10.984 4.709l-.413.005H13.922c-4.274.003-8.375-1.693-11.4-4.714-2.925-2.924-4.611-6.858-4.717-10.983l-.005-.413V20.322c-.003-4.277 1.694-8.38 4.719-11.403 2.926-2.927 6.863-4.611 10.988-4.714l.413-.005H36.8z"
            transform="translate(16 6)"
          />
          <path
            fill="#522181"
            d="M58.4 83.4c1.657 0 3 1.343 3 3 0 1.598-1.249 2.904-2.824 2.995l-.176.005H.8c-1.657 0-3-1.343-3-3 0-1.598 1.249-2.904 2.824-2.995L.8 83.4h57.6z"
            transform="translate(16 6)"
          />
          <path
            fill="#8451EC"
            d="M40.4 18.6c-7.622 0-13.8 6.178-13.8 13.8.007 7.62 6.18 13.793 13.797 13.8 7.625 0 13.803-6.178 13.803-13.8 0-7.622-6.178-13.8-13.8-13.8zm0 6c4.308 0 7.8 3.492 7.8 7.8s-3.492 7.8-7.8 7.8c-4.305-.004-7.796-3.495-7.8-7.803 0-4.305 3.492-7.797 7.8-7.797zM76.4 33c-7.622 0-13.8 6.178-13.8 13.8.007 7.62 6.18 13.793 13.797 13.8 7.625 0 13.803-6.178 13.803-13.8 0-7.622-6.178-13.8-13.8-13.8zm0 6c4.308 0 7.8 3.492 7.8 7.8s-3.492 7.8-7.8 7.8c-4.305-.004-7.796-3.495-7.8-7.803 0-4.305 3.492-7.797 7.8-7.797zM76.4-3c-7.622 0-13.8 6.178-13.8 13.8.007 7.62 6.18 13.793 13.797 13.8 7.625 0 13.803-6.178 13.803-13.8C90.2 3.178 84.022-3 76.4-3zm0 6c4.308 0 7.8 3.492 7.8 7.8s-3.492 7.8-7.8 7.8c-4.305-.004-7.796-3.495-7.8-7.803C68.6 6.492 72.092 3 76.4 3z"
            transform="translate(16 6)"
          />
          <path
            fill="#8451EC"
            d="M65.617 13.797c1.42-.852 3.263-.391 4.116 1.03.82 1.368.423 3.127-.876 4.017l-.154.099-17.52 10.51c-1.42.852-3.263.391-4.116-1.03-.82-1.368-.423-3.127.876-4.017l.154-.099 17.52-10.51zM47.634 35.267c.593-1.483 2.237-2.233 3.733-1.734l.166.061 16 6.39c1.538.614 2.288 2.36 1.673 3.899-.593 1.483-2.237 2.233-3.733 1.734l-.166-.061-16-6.39c-1.538-.614-2.288-2.36-1.673-3.899z"
            transform="translate(16 6)"
          />
        </g>
      </g>
    </g>
  ),
  "consumer-goods": (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#522181"
            d="M100.8 54.6c1.598 0 2.904 1.249 2.995 2.824l.005.176v43.2c0 5.54-4.416 10.047-9.92 10.196l-.28.004H14.4c-5.54 0-10.047-4.416-10.196-9.92l-.004-.28V57.6c0-1.657 1.343-3 3-3 1.598 0 2.904 1.249 2.995 2.824l.005.176v43.2c0 2.25 1.768 4.086 3.99 4.195l.21.005h79.2c2.25 0 4.086-1.768 4.195-3.99l.005-.21V57.6c0-1.657 1.343-3 3-3z"
            transform="translate(6 6)"
          />
          <path
            fill="#8451EC"
            d="M97.907-3h-87.82c-3.09.002-5.768 2.147-6.444 5.163L-2.93 31.75c-.047.213-.071.431-.071.65 0 7.622 6.178 13.8 13.8 13.8l.312-.003c4.154-.093 7.856-2.02 10.325-5.005l.163-.201.163.201C24.294 44.251 28.119 46.2 32.4 46.2l.312-.003c4.154-.093 7.856-2.02 10.325-5.005l.163-.201.163.201C45.894 44.251 49.719 46.2 54 46.2l.312-.003c4.154-.093 7.856-2.02 10.325-5.005l.163-.201.163.201C67.494 44.251 71.319 46.2 75.6 46.2l.312-.003c4.154-.093 7.856-2.02 10.325-5.005l.163-.201.163.201C89.094 44.251 92.919 46.2 97.2 46.2c7.622 0 13.8-6.178 13.8-13.8 0-.22-.024-.438-.072-.651l-6.58-29.58C103.686-.85 101.004-3.003 97.907-3zm.003 6l.092.007c.24.037.435.216.488.456l6.503 29.239-.008.191c-.255 4.078-3.643 7.307-7.785 7.307-4.308 0-7.8-3.492-7.8-7.8 0-3.931-5.795-3.999-5.995-.203l-.005.203c0 4.308-3.492 7.8-7.8 7.8s-7.8-3.492-7.8-7.8c0-3.931-5.795-3.999-5.995-.203l-.005.203c0 4.308-3.492 7.8-7.8 7.8s-7.8-3.492-7.8-7.8c0-3.931-5.795-3.999-5.995-.203l-.005.203c0 4.308-3.492 7.8-7.8 7.8s-7.8-3.492-7.8-7.8c0-3.931-5.795-3.999-5.995-.203l-.005.203c0 4.308-3.492 7.8-7.8 7.8l-.248-.004c-4.028-.125-7.287-3.306-7.537-7.303l-.009-.192 6.493-29.23c.06-.273.308-.471.593-.471H97.91z"
            transform="translate(6 6)"
          />
          <path
            fill="#522181"
            d="M68.4 76.2c1.657 0 3 1.343 3 3 0 1.598-1.249 2.904-2.824 2.995l-.176.005H7.2c-1.657 0-3-1.343-3-3 0-1.598 1.249-2.904 2.824-2.995L7.2 76.2h61.2z"
            transform="translate(6 6)"
          />
          <path
            fill="#522181"
            d="M68.4 54.6c1.598 0 2.904 1.249 2.995 2.824l.005.176V108c0 1.657-1.343 3-3 3-1.598 0-2.904-1.249-2.995-2.824L65.4 108V57.6c0-1.657 1.343-3 3-3z"
            transform="translate(6 6)"
          />
        </g>
      </g>
    </g>
  ),
  "coupon-engagement": (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#522181"
            d="M100.8-2.2H7.2C1.567-2.2-3 2.367-3 8v14.35c0 1.657 1.343 3 3 3 6.296 0 11.4 5.104 11.4 11.4S6.296 48.15 0 48.15c-1.657 0-3 1.343-3 3v14.4c0 2.705 1.075 5.3 2.988 7.212C1.9 74.675 4.495 75.75 7.2 75.75h93.6c5.633 0 10.2-4.567 10.2-10.2V51.2c0-1.657-1.343-3-3-3-6.296 0-11.4-5.104-11.4-11.4s5.104-11.4 11.4-11.4c1.657 0 3-1.343 3-3V8c0-5.633-4.567-10.2-10.2-10.2zm0 6l.21.005C103.232 3.915 105 5.751 105 8v11.658l-.197.035C96.72 21.194 90.6 28.283 90.6 36.8l.003.327c.154 8.372 6.221 15.298 14.2 16.78l.197.034V65.55c0 2.32-1.88 4.2-4.2 4.2H7.2c-1.114 0-2.182-.442-2.97-1.23l-.163-.173C3.382 67.579 3 66.584 3 65.55V53.891l.197-.034C11.28 52.356 17.4 45.267 17.4 36.75l-.003-.327c-.154-8.372-6.221-15.298-14.2-16.78L3 19.608V8c0-2.32 1.88-4.2 4.2-4.2h93.6z"
            transform="translate(6 24)"
          />
          <path
            fill="#8451EC"
            d="M36 12.15c-5.633 0-10.2 4.567-10.2 10.2 0 5.633 4.567 10.2 10.2 10.2 5.633 0 10.2-4.567 10.2-10.2 0-5.633-4.567-10.2-10.2-10.2zm0 6c2.32 0 4.2 1.88 4.2 4.2 0 2.32-1.88 4.2-4.2 4.2-2.32 0-4.2-1.88-4.2-4.2 0-2.32 1.88-4.2 4.2-4.2zM75.6 40.95c-5.633 0-10.2 4.567-10.2 10.2 0 2.705 1.075 5.3 2.988 7.212 1.912 1.913 4.507 2.988 7.212 2.988 5.633 0 10.2-4.567 10.2-10.2 0-5.633-4.567-10.2-10.2-10.2zm0 6c2.32 0 4.2 1.88 4.2 4.2 0 2.32-1.88 4.2-4.2 4.2-1.114 0-2.182-.442-2.97-1.23-.788-.788-1.23-1.856-1.23-2.97 0-2.32 1.88-4.2 4.2-4.2zM69.879 16.629c1.171-1.172 3.07-1.172 4.242 0 1.125 1.124 1.17 2.92.135 4.098l-.135.144-36 36c-1.171 1.172-3.07 1.172-4.242 0-1.125-1.124-1.17-2.92-.135-4.098l.135-.144 36-36z"
            transform="translate(6 24)"
          />
        </g>
      </g>
    </g>
  ),
  "data-computer": (
    <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g strokeWidth="6">
        <g>
          <path
            stroke="#522181"
            d="M66.97 101.52L38.77 101.52 42.3 81.22 63.45 81.22zM28.2 101.52L77.55 101.52M0 14.1C0 6.313 6.313 0 14.1 0h77.55c7.787 0 14.1 6.313 14.1 14.1v53c0 7.787-6.313 14.1-14.1 14.1H14.1C6.313 81.2 0 74.887 0 67.1v-53z"
            transform="translate(7 9)"
          />
          <path
            stroke="#8451EC"
            d="M35.25 60.91c11.68 0 21.15-9.09 21.15-20.3S46.93 20.3 35.25 20.3c-11.68 0-21.15 9.09-21.15 20.31 0 11.22 9.47 20.3 21.15 20.3z"
            transform="translate(7 9)"
          />
          <path
            stroke="#8451EC"
            d="M35.25 20.3L35.25 40.61 50.25 54.97M70.5 27.07L84.6 27.07M70.5 40.61L84.6 40.61M70.5 54.14L84.6 54.14"
            transform="translate(7 9)"
          />
        </g>
      </g>
    </g>
  ),
  demographics: (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#522181"
            d="M108 83.4c1.598 0 2.904 1.249 2.995 2.824l.005.176v14.4c0 5.54-4.416 10.047-9.92 10.196l-.28.004H86.39c-1.657 0-3-1.343-3-3 0-1.598 1.249-2.904 2.824-2.995l.176-.005h14.41c2.25 0 4.086-1.768 4.195-3.99l.005-.21V86.4c0-1.657 1.343-3 3-3zM100.79-3c5.54 0 10.047 4.416 10.196 9.92l.004.28v14.4c0 1.657-1.343 3-3 3-1.598 0-2.904-1.249-2.995-2.824l-.005-.176V7.2c0-2.25-1.768-4.086-3.99-4.195L100.79 3h-14.4c-1.657 0-3-1.343-3-3 0-1.598 1.249-2.904 2.824-2.995L86.39-3h14.4zM21.59-3c1.657 0 3 1.343 3 3 0 1.598-1.249 2.904-2.824 2.995L21.59 3H7.194c-2.247.003-4.08 1.77-4.189 3.99L3 7.2v14.4c0 1.657-1.343 3-3 3-1.598 0-2.904-1.249-2.995-2.824L-3 21.6V7.2C-3 1.666 1.407-2.84 6.91-2.996L7.19-3h14.4zM0 83.4c1.598 0 2.904 1.249 2.995 2.824L3 86.4v14.4c0 2.247 1.765 4.082 3.981 4.195l.209.005h14.4c1.657 0 3 1.343 3 3 0 1.598-1.249 2.904-2.824 2.995l-.176.005H7.186c-5.534-.008-10.034-4.421-10.182-9.92L-3 100.8V86.4c0-1.657 1.343-3 3-3z"
            transform="translate(6 6)"
          />
          <path
            fill="#8451EC"
            d="M54 16.82c-12.592 0-22.8 10.208-22.8 22.8-.003 6.047 2.398 11.848 6.675 16.125 4.277 4.277 10.078 6.678 16.127 6.675 12.59 0 22.798-10.208 22.798-22.8S66.592 16.82 54 16.82zm0 6c9.278 0 16.8 7.522 16.8 16.8s-7.522 16.8-16.8 16.8c-4.457.002-8.732-1.767-11.882-4.918-3.151-3.15-4.92-7.425-4.918-11.88 0-9.28 7.522-16.802 16.8-16.802zM53.995 63.577c15.004 0 28.38 9.457 33.383 23.603.553 1.562-.266 3.276-1.828 3.828-1.562.553-3.276-.266-3.828-1.828-4.156-11.748-15.265-19.603-27.727-19.603S30.424 77.432 26.268 89.18c-.552 1.562-2.266 2.38-3.828 1.828-1.562-.552-2.38-2.266-1.828-3.828 5.003-14.146 18.379-23.603 33.383-23.603z"
            transform="translate(6 6)"
          />
        </g>
      </g>
    </g>
  ),
  health: (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#522181"
            d="M27.764 67.274c1.149-1.1 2.945-1.107 4.101-.048l.141.138 21.56 22.501c.114.118.27.185.434.185.13 0 .257-.043.361-.12l.073-.066 21.56-22.49c1.147-1.196 3.046-1.236 4.242-.09 1.148 1.101 1.231 2.895.222 4.095l-.132.147-21.56 22.489C57.523 95.315 55.8 96.05 54 96.05c-1.7 0-3.33-.656-4.554-1.823l-.212-.211-21.56-22.5c-1.146-1.197-1.106-3.096.09-4.242zM59.398 6.009c6.87-6.872 16.625-10.022 26.217-8.467 9.591 1.555 17.85 7.626 22.2 16.319 4.461 8.942 4.22 19.51-.644 28.24-.807 1.447-2.634 1.966-4.081 1.16-1.448-.807-1.967-2.634-1.16-4.081 3.9-6.999 4.093-15.472.517-22.638C98.963 9.577 92.342 4.711 84.654 3.464 77.11 2.241 69.438 4.651 63.948 9.95l-.308.303-7.52 7.51c-1.123 1.122-2.915 1.168-4.093.137l-.144-.134-7.525-7.495c-5.505-5.507-13.323-8.03-21.01-6.783C15.662 4.737 9.044 9.604 5.564 16.57c-3.58 7.168-3.387 15.642.516 22.639.807 1.447.288 3.274-1.159 4.081-1.447.807-3.274.288-4.081-1.159-4.869-8.729-5.11-19.3-.644-28.242C4.54 5.197 12.796-.877 22.386-2.434c9.431-1.532 19.02 1.488 25.865 8.118l.346.34 5.4 5.378 5.401-5.393z"
            transform="translate(6 13)"
          />
          <path
            fill="#8451EC"
            d="M30.545 52.05l7.921-15.84c.87-1.81 2.78-2.884 4.747-2.688 1.905.167 3.523 1.446 4.125 3.218l.065.207 7.11 23.679 6.235-14.564c.681-1.533 2.107-2.599 3.746-2.823l.225-.026c1.676-.157 3.306.572 4.315 1.927l.134.188L73.607 52H108c1.598 0 2.904 1.249 2.995 2.824L111 55c0 1.598-1.249 2.904-2.824 2.995L108 58H72c-.937 0-1.816-.437-2.381-1.175l-.117-.163-4.117-6.188-6.703 15.657c-.797 1.72-2.527 2.806-4.41 2.788l-.226-.007c-1.896-.108-3.545-1.32-4.243-3.155l-.076-.214-7.213-24.015-6.931 13.865c-.778 1.553-2.33 2.562-4.066 2.65l-.227.007H0c-1.657 0-3-1.343-3-3 0-1.598 1.249-2.904 2.824-2.995L0 52.05h30.545z"
            transform="translate(6 13)"
          />
        </g>
      </g>
    </g>
  ),
  idea: (
    <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g strokeWidth="6">
        <g>
          <path
            stroke="#522181"
            d="M42.298 0L42.298 7.05M7.048 35.25L14.598 35.25M77.548 35.25L69.998 35.25M13.218 12.22L19.638 18.64M71.368 12.22L64.958 18.64M15.098 49.35c-1.172-.03-2.308.408-3.158 1.216-.85.809-1.343 1.922-1.372 3.094v30.16c.066 2.439 2.09 4.366 4.53 4.31h54.37c1.172.03 2.308-.408 3.158-1.216.85-.809 1.343-1.922 1.372-3.094V53.66c-.029-1.172-.522-2.285-1.372-3.094-.85-.808-1.986-1.246-3.158-1.216"
            transform="translate(17.402 7.01)"
          />
          <path
            stroke="#522181"
            d="M10.568 88.13l-8.78 7.6C.647 96.809 0 98.31 0 99.88c0 1.57.647 3.071 1.788 4.15h0c1.17 1.112 2.726 1.729 4.34 1.72h72.34c1.611.007 3.163-.61 4.33-1.72h0c1.15-1.074 1.802-2.577 1.802-4.15 0-1.573-.653-3.076-1.802-4.15l-8.8-7.6h-63.43z"
            transform="translate(17.402 7.01)"
          />
          <path
            stroke="#8451EC"
            d="M59.918 35.25c.004-8.801-6.487-16.255-15.204-17.462-8.718-1.206-16.99 4.205-19.376 12.676-2.386 8.472 1.844 17.405 9.91 20.926v8.54h14.1v-8.54c6.421-2.798 10.572-9.136 10.57-16.14z"
            transform="translate(17.402 7.01)"
          />
          <path stroke="#522181" d="M35.248 70.5L49.348 70.5" transform="translate(17.402 7.01)" />
        </g>
      </g>
    </g>
  ),
  magnify: (
    <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g strokeWidth="6">
        <g>
          <path
            stroke="#522181"
            d="M39.82 40.95C17.11 39.04 0 30.7 0 20.7 0 9.27 22.24 0 49.68 0s49.68 9.27 49.68 20.7c0 5.44-5 10.38-13.25 14.08M99.36 48.25L99.36 20.7"
            transform="translate(10.19 8.19)"
          />
          <path
            stroke="#522181"
            d="M0 20.7v27.6c0 8.51 12.33 15.82 30 19"
            transform="translate(10.19 8.19)"
          />
          <path
            stroke="#522181"
            d="M0 48.25v27.6c0 10 17.11 18.4 39.82 20.3"
            transform="translate(10.19 8.19)"
          />
          <path
            stroke="#8451EC"
            d="M66.24 93.1c12.8 0 23.18-10.81 23.18-24.15 0-13.34-10.38-24.15-23.18-24.15-12.8 0-23.19 10.82-23.19 24.15 0 13.33 10.38 24.15 23.19 24.15zM99.36 103.45L82.68 86.02"
            transform="translate(10.19 8.19)"
          />
        </g>
      </g>
    </g>
  ),
  media: (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#522181"
            d="M28.197 54.76c1.657.01 2.992 1.36 2.983 3.017-.05 8.66 3.368 16.978 9.491 23.102 1.172 1.171 1.172 3.07 0 4.242-1.171 1.172-3.07 1.172-4.242 0-7.257-7.257-11.308-17.116-11.249-27.378.01-1.657 1.36-2.992 3.017-2.983z"
            transform="translate(8 19)"
          />
          <path
            fill="#522181"
            d="M28.18 18.76H17.81c-11.226 0-20.28 9.43-20.28 21s9.054 21 20.28 21h10.37c1.657 0 3-1.343 3-3v-36c0-1.657-1.343-3-3-3zm-3 6v30h-7.37c-7.856 0-14.28-6.691-14.28-15l.003-.323c.164-8.159 6.523-14.677 14.277-14.677h7.37z"
            transform="translate(8 19)"
          />
          <path
            fill="#522181"
            d="M88.7-2.305l-5.23 3.63C67.248 12.661 47.953 18.755 28.174 18.79c-1.655.003-2.995 1.345-2.995 3v35.97c0 1.655 1.34 2.997 2.995 3 19.497.035 38.522 5.956 54.59 16.977l5.934 4.118c1.99 1.38 4.711-.043 4.711-2.465V.16c0-2.422-2.721-3.845-4.71-2.465zm-1.29 8.199v67.762l-1.219-.845C70.062 61.737 51.113 55.504 31.587 54.822l-.408-.012V24.739l.408-.011c19.514-.681 38.45-6.907 54.58-17.973l1.243-.861z"
            transform="translate(8 19)"
          />
          <path
            fill="#8451EC"
            d="M104.21 29.56c1.598 0 2.904 1.249 2.995 2.824l.005.176V47c0 1.657-1.343 3-3 3-1.598 0-2.904-1.249-2.995-2.824L101.21 47V32.56c0-1.657 1.343-3 3-3z"
            transform="translate(8 19)"
          />
        </g>
      </g>
    </g>
  ),
  network: (
    <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g strokeWidth="6">
        <g>
          <path
            stroke="#522181"
            d="M54.99 55.01c4.451.005 8.467-2.674 10.173-6.785 1.707-4.112.768-8.847-2.378-11.996-3.147-3.15-7.88-4.093-11.994-2.39-4.113 1.703-6.795 5.716-6.795 10.167 0 6.074 4.92 10.999 10.994 11.005zM73.316 73.337C71.082 64.96 63.65 59.019 54.99 58.682c-8.662.337-16.093 6.28-18.327 14.655M54.99 18.347c3.712.005 7.06-2.229 8.483-5.658 1.423-3.429.639-7.377-1.986-10.002C58.862.062 54.913-.722 51.485.701c-3.43 1.422-5.663 4.771-5.659 8.483 0 5.06 4.103 9.163 9.164 9.163zM100.816 64.153c3.714.004 7.064-2.232 8.485-5.663 1.422-3.432.634-7.381-1.996-10.005-2.629-2.623-6.58-3.402-10.009-1.973-3.428 1.43-5.656 4.784-5.643 8.499.017 5.05 4.113 9.136 9.163 9.142zM54.99 110.01c3.71.005 7.059-2.228 8.482-5.655 1.423-3.428.641-7.375-1.982-10.001-2.623-2.626-6.569-3.413-9.998-1.993-3.43 1.419-5.666 4.765-5.666 8.476-.002 2.432.962 4.765 2.68 6.486 1.72 1.72 4.051 2.687 6.484 2.687h0zM9.163 64.153c3.714.004 7.065-2.232 8.486-5.663 1.421-3.432.633-7.381-1.996-10.005-2.63-2.623-6.581-3.402-10.01-1.973C2.217 47.942-.012 51.296 0 55.011c.017 5.05 4.113 9.136 9.163 9.142z"
            transform="translate(5 5)"
          />
          <path
            stroke="#8451EC"
            d="M76.987 16.88c6.7 3.87 12.263 9.434 16.132 16.133M93.12 77.008c-3.87 6.7-9.434 12.263-16.133 16.132M32.992 93.14c-6.695-3.875-12.257-9.437-16.132-16.132M16.86 33.013c3.875-6.695 9.437-12.257 16.132-16.132"
            transform="translate(5 5)"
          />
        </g>
      </g>
    </g>
  ),
  "purchase-data": (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#8451EC"
            d="M24.739 9c1.657.005 2.996 1.352 2.991 3.009-.005 1.597-1.257 2.9-2.832 2.986L24.72 15c-1.946-.006-3.813.767-5.186 2.145-1.3 1.306-2.056 3.053-2.12 4.888l-.005.307c.011 1.656-1.323 3.009-2.98 3.02-1.656.011-3.009-1.323-3.02-2.98-.024-3.547 1.37-6.956 3.874-9.47 2.504-2.512 5.908-3.92 9.455-3.91zM18.903-2.24C20.56-2.238 21.902-.894 21.9.763c-.002 1.598-1.252 2.903-2.827 2.992l-.176.005c-4.218-.004-8.264 1.669-11.246 4.651-2.886 2.886-4.546 6.768-4.646 10.838L3 19.657c.002 1.657-1.34 3.001-2.997 3.003-1.657.002-3.001-1.34-3.003-2.997-.006-5.81 2.3-11.386 6.408-15.495C7.518.06 13.092-2.246 18.903-2.24zM24.1 30.16h63.393c2.788-.016 5.428 1.255 7.156 3.444 1.663 2.108 2.3 4.84 1.753 7.459l-.068.301-.037.137-1.5 5.07c-.47 1.589-2.14 2.496-3.728 2.026-1.532-.454-2.43-2.022-2.07-3.558l.044-.17 1.472-4.975.033-.154c.138-.788-.038-1.599-.49-2.258l-.12-.161c-.54-.685-1.346-1.104-2.224-1.156l-.204-.005H24.061c-.934-.012-1.82.411-2.397 1.145-.536.682-.75 1.559-.591 2.405l.034.156 9.102 31.08.028.103c.332 1.304 1.472 2.232 2.81 2.306l.183.005H46.8c1.657 0 3 1.343 3 3 0 1.598-1.249 2.904-2.824 2.995l-.176.005H33.239c-4.064.012-7.627-2.678-8.744-6.562l-.044-.165-9.12-31.14-.027-.098c-.696-2.714-.088-5.597 1.643-7.799 1.67-2.123 4.202-3.38 6.857-3.435l.296-.001z"
            transform="translate(6 6)"
          />
          <path
            fill="#8451EC"
            d="M70.96 12.231c1.559-.346 3.105.59 3.535 2.107l.044.171 4 18c.359 1.618-.66 3.22-2.278 3.58-1.56.346-3.106-.59-3.536-2.107l-.044-.171-4-18c-.359-1.618.66-3.22 2.278-3.58zM40.681 14.51c.36-1.618 1.962-2.638 3.58-2.279 1.56.347 2.563 1.85 2.31 3.407l-.032.173-4 18c-.36 1.617-1.962 2.637-3.58 2.278-1.56-.347-2.563-1.85-2.31-3.407l.032-.173 4-18z"
            transform="translate(6 6)"
          />
          <path
            fill="#522181"
            d="M69.52 44.56c5.54 0 10.047 4.416 10.196 9.92l.004.28v26.384l17.652 3.928c8.431 1.877 14.191 9.647 13.574 18.22l-.028.344-.48 5.39c-.147 1.65-1.604 2.87-3.254 2.722-1.591-.142-2.782-1.501-2.733-3.078l.01-.176.482-5.398c.514-5.612-3.148-10.741-8.587-12.1l-.288-.068-20-4.45c-1.312-.292-2.262-1.418-2.343-2.746l-.005-.182V54.76c0-2.32-1.88-4.2-4.2-4.2-2.25 0-4.086 1.768-4.195 3.99l-.005.21v46.8c0 2.417-2.698 3.82-4.666 2.495l-.136-.096-8.167-6.136c-1.732-1.31-4.163-1.142-5.698.392-1.483 1.481-1.692 3.799-.534 5.509l.13.18 2.28 3c1.002 1.32.745 3.202-.574 4.204-1.268.964-3.057.764-4.084-.425l-.12-.148-2.286-3.008c-3.11-4.122-2.706-9.907.947-13.556 3.582-3.579 9.212-4.032 13.306-1.118l.244.178 3.358 2.523V54.76c0-5.54 4.416-10.047 9.92-10.196l.28-.004z"
            transform="translate(6 6)"
          />
        </g>
      </g>
    </g>
  ),
  "ratings-#1-award": (
    <svg viewBox="0 0 111.76 111.76">
      <path
        d="M26.19,64.9,7.12,88.2l17.63,3.52,7.05,21.16L50.34,83.46"
        transform="translate(-4.12 -4.12)"
        fill="none"
        stroke="#8451ec"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M93.81,64.9l19.07,23.3L95.25,91.72l-7,21.16L69.66,83.46"
        transform="translate(-4.12 -4.12)"
        fill="none"
        stroke="#8451ec"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M60,84.68A38.78,38.78,0,1,0,21.22,45.9,38.78,38.78,0,0,0,60,84.68Z"
        transform="translate(-4.12 -4.12)"
        fill="none"
        stroke="#522181"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M56.47,28.28H60a3.53,3.53,0,0,1,3.53,3.51h0V56.47"
        transform="translate(-4.12 -4.12)"
        fill="none"
        stroke="#522181"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M56.47,56.47H70.58"
        transform="translate(-4.12 -4.12)"
        fill="none"
        stroke="#522181"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
    </svg>
  ),
  "trade-associations": (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <g fill="#522181">
            <path
              d="M59.55 50.23c1.657 0 3 1.343 3 3 0 1.598-1.249 2.904-2.824 2.995l-.176.005H8.85c-1.657 0-3-1.343-3-3 0-1.598 1.249-2.904 2.824-2.995l.176-.005h50.7zM40.6-2.42c1.345-.858 3.114-.507 4.038.768l.103.151 25.51 40.08c.89 1.398.478 3.252-.92 4.142-1.346.857-3.115.506-4.04-.769l-.102-.151L39.68 1.72c-.89-1.398-.478-3.252.92-4.142zM23.66-1.5c.889-1.399 2.743-1.81 4.14-.92 1.347.856 1.779 2.607 1.014 3.984l-.093.157L3.21 41.8c-.89 1.398-2.744 1.81-4.142.92-1.346-.857-1.778-2.608-1.013-3.985l.093-.157L23.66-1.5z"
              transform="translate(5 5) translate(21 36)"
            />
          </g>
          <g fill="#8451EC">
            <path
              d="M13.31 78.98c-6.191 0-11.21 5.019-11.21 11.21-.004 2.972 1.177 5.826 3.28 7.93 2.104 2.103 4.958 3.284 7.934 3.28 6.187 0 11.206-5.019 11.206-11.21 0-6.191-5.019-11.21-11.21-11.21zm0 6c2.877 0 5.21 2.333 5.21 5.21s-2.333 5.21-5.21 5.21c-1.385.002-2.71-.546-3.687-1.523-.977-.977-1.525-2.302-1.523-3.683 0-2.881 2.333-5.214 5.21-5.214z"
              transform="translate(5 5)"
            />
            <path
              d="M13.33 98.374c6.965 0 13.174 4.389 15.498 10.955.553 1.562-.265 3.276-1.827 3.83-1.562.552-3.276-.266-3.83-1.828-1.475-4.17-5.418-6.957-9.841-6.957-4.423 0-8.366 2.787-9.842 6.957-.553 1.562-2.267 2.38-3.829 1.827-1.562-.553-2.38-2.267-1.827-3.829 2.324-6.566 8.533-10.955 15.498-10.955zM96.93 78.98c-6.191 0-11.21 5.019-11.21 11.21 0 6.191 5.019 11.21 11.21 11.21 6.191 0 11.21-5.019 11.21-11.21 0-6.191-5.019-11.21-11.21-11.21zm0 6c2.877 0 5.21 2.333 5.21 5.21s-2.333 5.21-5.21 5.21-5.21-2.333-5.21-5.21 2.333-5.21 5.21-5.21z"
              transform="translate(5 5)"
            />
            <path
              d="M96.93 98.374c6.965 0 13.174 4.389 15.498 10.955.553 1.562-.265 3.276-1.827 3.83-1.562.552-3.276-.266-3.83-1.828-1.475-4.17-5.418-6.957-9.841-6.957-4.423 0-8.366 2.787-9.842 6.957-.553 1.562-2.267 2.38-3.829 1.827-1.562-.553-2.38-2.267-1.827-3.829 2.324-6.566 8.533-10.955 15.498-10.955zM55-2.08c-6.191 0-11.21 5.019-11.21 11.21 0 6.191 5.019 11.21 11.21 11.21 6.191 0 11.21-5.019 11.21-11.21 0-6.191-5.019-11.21-11.21-11.21zm0 6c2.877 0 5.21 2.333 5.21 5.21s-2.333 5.21-5.21 5.21-5.21-2.333-5.21-5.21S52.123 3.92 55 3.92z"
              transform="translate(5 5)"
            />
            <path
              d="M55 17.314c6.965 0 13.174 4.389 15.498 10.955.553 1.562-.265 3.276-1.827 3.83-1.562.552-3.276-.266-3.83-1.828-1.475-4.17-5.418-6.957-9.841-6.957-4.423 0-8.366 2.787-9.842 6.957-.553 1.562-2.267 2.38-3.829 1.827-1.562-.553-2.38-2.267-1.827-3.829C41.826 21.703 48.035 17.314 55 17.314z"
              transform="translate(5 5)"
            />
          </g>
        </g>
      </g>
    </g>
  ),
  "technical-maturity": (
    <g>
      <path
        d="M3 77.02c0-1.95 1.57-3.52 3.52-3.53h17.59a3.52 3.52 0 0 1 3.52 3.53v28.2c0 1.94-1.58 3.51-3.52 3.52H6.52c-1.94 0-3.51-1.58-3.52-3.52v-28.2ZM80.55 91.12a3.53 3.53 0 0 1 3.53-3.53h17.66a3.52 3.52 0 0 1 3.52 3.53v14.1c0 1.94-1.58 3.51-3.52 3.52H84.11c-1.94 0-3.51-1.58-3.52-3.52l-.04-14.1ZM41.77 62.92a3.53 3.53 0 0 1 3.53-3.53h17.62a3.53 3.53 0 0 1 3.53 3.53v42.3a3.52 3.52 0 0 1-3.53 3.52H45.3c-1.95 0-3.52-1.57-3.53-3.52v-42.3Z"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="m58.36 4.52 5.87 11.54h10a2.746 2.746 0 0 1 2.83 2.65c.02.77-.28 1.51-.83 2.05l-9.18 9 5.06 11.69c.6 1.41-.05 3.05-1.46 3.65-.83.35-1.77.29-2.54-.18L55.87 38l-12.29 6.92c-1.32.77-3.02.31-3.78-1.01-.43-.75-.49-1.66-.16-2.46l5.07-11.67-9.16-9a2.743 2.743 0 0 1-.05-3.87c.54-.55 1.28-.85 2.05-.83h10L53.4 4.5c.49-.92 1.45-1.5 2.49-1.5 1.04 0 2 .59 2.47 1.52Z"
        style={{
          fill: "none",
          stroke: "#8451ec",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
    </g>
  ),
  "change-makers": (
    <g>
      <path
        d="M99.41 3 89.3 4.12a34.96 34.96 0 0 0-20.89 10.03L22.76 59.84l19.75 19.77 45.71-45.7a34.9 34.9 0 0 0 10-20.85L99.41 3Z"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M22.75 59.84 5.88 54.21a3.485 3.485 0 0 1-2.21-4.41c.17-.52.46-.98.84-1.37l1.08-1.08a27.994 27.994 0 0 1 28.61-6.76l5.85 2-17.3 17.25Z"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M22.75 59.84 5.88 54.21a3.485 3.485 0 0 1-2.21-4.41c.17-.52.46-.98.84-1.37l1.08-1.08a27.994 27.994 0 0 1 28.61-6.76l5.85 2-17.3 17.25ZM42.51 79.61l5.63 16.87a3.485 3.485 0 0 0 4.41 2.21c.52-.17.98-.46 1.37-.84l1.09-1.08a27.99 27.99 0 0 0 6.75-28.61l-1.94-5.83-17.31 17.28Z"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="m42.51 79.61 5.63 16.87a3.485 3.485 0 0 0 4.41 2.21c.52-.17.98-.46 1.37-.84l1.09-1.08a27.99 27.99 0 0 0 6.75-28.61l-1.94-5.83-17.31 17.28Z"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M30.76 82.08c0 2.78-1.1 5.45-3.07 7.42C23.6 93.59 3 99.43 3 99.43s5.79-20.62 9.88-24.7a10.49 10.49 0 0 1 6.73-3"
        style={{
          fill: "none",
          stroke: "#8451ec",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
    </g>
  ),
  aspiring: (
    <g>
      <path
        d="M66.45 80.56v10.57a7.06 7.06 0 0 1-7 7h-14.1c-3.87 0-7.02-3.13-7.05-7V80.56"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M52.35 3v7.06M3 52.35h7M13.58 17.1l5.17 5M101.7 52.35h-7M91.12 17.1l-5.17 5"
        style={{
          fill: "none",
          stroke: "#8451ec",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M37.85 80.56h29a31.002 31.002 0 0 0 17.22-28.21c-.31-17.39-14.33-31.41-31.72-31.72-17.4.3-31.43 14.34-31.73 31.74a31 31 0 0 0 17.23 28.19ZM52.35 98.18v10.58M52.35 62.93v17.63"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="m41.77 52.35 10.58 10.58 10.58-10.58"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
    </g>
  ),
  "cultural-maturity": (
    <g>
      <path
        d="M38.26 80.56h-28.2A6.995 6.995 0 0 0 3 87.5v21.22h35.26V80.56ZM101.7 80.56H73.5v28.2h35.26V87.6a6.995 6.995 0 0 0-6.96-7.04h-.1ZM66.45 52.35H45.31c-3.88.03-7.01 3.18-7 7.06v49.35H73.5V59.41c0-3.89-3.15-7.05-7.04-7.06h-.01Z"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M55.88 27.68c6.82 0 12.34-5.52 12.34-12.34S62.7 3 55.88 3 43.54 8.52 43.54 15.34h0c0 6.82 5.52 12.34 12.34 12.34ZM71.15 38.26c-7.17-8.44-19.83-9.46-28.26-2.29-.82.7-1.59 1.46-2.29 2.29M93.48 59.41c6.82 0 12.34-5.51 12.35-12.33 0-6.82-5.51-12.34-12.33-12.35-6.82 0-12.34 5.51-12.35 12.33h0c0 6.82 5.52 12.34 12.33 12.35ZM108.76 69.98a20.004 20.004 0 0 0-21.16-6.16M18.28 59.41c6.82 0 12.34-5.52 12.34-12.34S25.1 34.73 18.28 34.73 5.94 40.25 5.94 47.07h0c0 6.82 5.52 12.34 12.34 12.34ZM3 69.98c5.18-6.1 13.49-8.52 21.13-6.17"
        style={{
          fill: "none",
          stroke: "#8451ec",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
    </g>
  ),
  "just-starting": (
    <g>
      <path
        d="m105.82 69.36-35.9 35.86-17.62 3.52 3.52-17.62 35.86-35.86a9.995 9.995 0 0 1 14.07 0h0c3.88 3.87 3.9 10.15.03 14.03l-.03.03.07.04Z"
        style={{
          fill: "none",
          stroke: "#8451ec",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M38.2 94.65H10c-3.8.06-6.94-2.97-7-6.78V17.65c-.13-4.03 3.02-7.41 7.05-7.55h70.5c4.01.17 7.14 3.54 7 7.55v20.6M24.1 3v21.15M45.25 3v21.15M66.4 3v21.15"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
    </g>
  ),
  "untapped-potential": (
    <g>
      <path
        d="m94.66 31.2 14.1-14.1L94.66 3"
        style={{
          fill: "none",
          stroke: "#8451ec",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M17.1 73.5 3 87.6l14.1 14.11"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M108.76 17.1h-26M67.27 17.1h-14M38.49 20.49c-3.81 2.8-6.34 7.02-7 11.71"
        style={{
          fill: "none",
          stroke: "#8451ec",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
      <path
        d="M35.76 46.52c3.18 3.53 7.65 5.62 12.39 5.8M63.61 52.4c4.74.18 9.21 2.27 12.39 5.8M80.35 72.51a17.66 17.66 0 0 1-7 11.72M58.54 87.6h-14M29.02 87.6h-26"
        style={{
          fill: "none",
          stroke: "#522181",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6
        }}
      />
    </g>
  ),
  user_centered: (
    <svg viewBox="0 0 34 34">
      <path
        d="M6.65838 5.96339L9.33989 7.90647M6.65838 27.3112L9.33989 25.3652M26.6133 5.96339L23.9347 7.90647M26.6133 27.3112L23.9347 25.3652M4.12746 7.25492C5.8548 7.25492 7.25492 5.8548 7.25492 4.12746C7.25492 2.40012 5.8548 1 4.12746 1C2.40012 1 1 2.40012 1 4.12746C1.00174 5.85393 2.40099 7.25318 4.12746 7.25492ZM4.12746 32.2746C5.8548 32.2746 7.25492 30.8745 7.25492 29.1471C7.25492 27.4198 5.8548 26.0197 4.12746 26.0197C2.40012 26.0197 1 27.4198 1 29.1471C1.00174 30.8736 2.40099 32.2729 4.12746 32.2746ZM29.1471 7.25492C30.8745 7.25492 32.2746 5.8548 32.2746 4.12746C32.2746 2.40012 30.8745 1 29.1471 1C27.4198 1 26.0197 2.40012 26.0197 4.12746C26.0214 5.85393 27.4207 7.25318 29.1471 7.25492ZM29.1471 32.2746C30.8745 32.2746 32.2746 30.8745 32.2746 29.1471C32.2746 27.4198 30.8745 26.0197 29.1471 26.0197C27.4198 26.0197 26.0197 27.4198 26.0197 29.1471C26.0214 30.8736 27.4207 32.2729 29.1471 32.2746Z"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6372 14.5524C17.3589 14.5524 18.0644 14.3385 18.6645 13.9375C19.2646 13.5366 19.7323 12.9667 20.0085 12.3C20.2846 11.6333 20.3569 10.8996 20.2161 10.1918C20.0753 9.48395 19.7277 8.83379 19.2174 8.32351C18.7071 7.81318 18.057 7.46563 17.3491 7.32482C16.6413 7.18402 15.9077 7.25627 15.2409 7.53246C14.5742 7.80864 14.0043 8.27634 13.6034 8.87642C13.2025 9.47649 12.9885 10.182 12.9885 10.9037C12.9885 12.9189 14.6221 14.5524 16.6372 14.5524ZM10.3823 21.8498C10.3823 21.0284 10.5441 20.215 10.8585 19.4561C11.1728 18.6972 11.6335 18.0077 12.2143 17.4269C12.7952 16.8461 13.4847 16.3853 14.2436 16.071C15.0025 15.7566 15.8158 15.5949 16.6372 15.5949C17.4586 15.5949 18.272 15.7566 19.0309 16.071C19.7898 16.3853 20.4793 16.8461 21.0601 17.4269C21.641 18.0077 22.1017 18.6972 22.416 19.4561C22.7304 20.215 22.8922 21.0284 22.8922 21.8498H10.3823Z"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  wealth_graph: (
    <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.6577 29.8495L30.5843 26.7423V19.4449C30.5843 16.6649 25.3024 13.6909 23.2869 12.1475M25.9713 21.2432L20.9008 17.189C20.558 16.8636 20.1017 16.6849 19.6291 16.6911C19.1565 16.6972 18.705 16.8876 18.3708 17.2218C18.0366 17.5561 17.8461 18.0076 17.84 18.4802C17.8339 18.9528 18.0126 19.4091 18.338 19.7518L23.2608 25.2944V28.7693C23.2608 30.4083 25.6064 33.0001 25.6064 33.0001"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1168 30.9122H3.30576C2.7991 30.9115 2.31342 30.7099 1.95516 30.3516C1.5969 29.9934 1.3953 29.5077 1.39453 29.001V3.63095C1.39453 3.12407 1.59589 2.63794 1.95432 2.27951C2.31274 1.92109 2.79887 1.71973 3.30576 1.71973H21.3755C21.6264 1.71927 21.8749 1.7683 22.1068 1.86401C22.3387 1.95971 22.5494 2.10021 22.727 2.27747C22.9045 2.45473 23.0453 2.66526 23.1414 2.89701C23.2374 3.12877 23.2868 3.37719 23.2867 3.62806V19.0945"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9043 5.89258H18.0743M18.0743 5.89258V10.0625M18.0743 5.89258L5.56445 17.357M7.63784 22.5695V26.7394M11.8078 19.4449V26.7423"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  happiness_graph: (
    <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.1896 1.51025L19.9733 11.7266C19.6243 12.076 19.1626 12.2902 18.6705 12.331C18.1784 12.3718 17.6877 12.2367 17.286 11.9496L12.7077 8.68024C12.3383 8.4167 11.8929 8.28089 11.4393 8.29344C10.9856 8.30598 10.5485 8.46619 10.1942 8.74974L1 16.1051"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8496 1.51025H30.1895V9.85014"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8072 20.2752C20.5308 20.2752 20.2656 20.385 20.0701 20.5805C19.8746 20.776 19.7648 21.0412 19.7648 21.3177V23.4026C19.7648 23.6791 19.8746 23.9443 20.0701 24.1398C20.2656 24.3353 20.5308 24.4451 20.8072 24.4451H31.2321C31.5086 24.4451 31.7737 24.3353 31.9693 24.1398C32.1648 23.9443 32.2746 23.6791 32.2746 23.4026V21.3177C32.2746 21.0412 32.1648 20.776 31.9693 20.5805C31.7737 20.385 31.5086 20.2752 31.2321 20.2752M20.8072 20.2752H31.2321M20.8072 20.2752C20.5308 20.2752 20.2656 20.1653 20.0701 19.9698C19.8746 19.7743 19.7648 19.5092 19.7648 19.2327V17.1477C19.7648 16.8712 19.8746 16.6061 20.0701 16.4106C20.2656 16.2151 20.5308 16.1052 20.8072 16.1052H31.2321C31.369 16.1052 31.5046 16.1322 31.631 16.1846C31.7575 16.237 31.8725 16.3138 31.9693 16.4106C32.0661 16.5074 32.1428 16.6223 32.1952 16.7488C32.2476 16.8752 32.2746 17.0108 32.2746 17.1477V19.2327C32.2746 19.5092 32.1648 19.7743 31.9693 19.9698C31.7737 20.1653 31.5086 20.2752 31.2321 20.2752M19.7648 29.6575C19.7648 29.3811 19.8746 29.1159 20.0701 28.9204C20.2656 28.7249 20.5308 28.6151 20.8072 28.6151H31.2321C31.5086 28.6151 31.7737 28.7249 31.9693 28.9204C32.1648 29.1159 32.2746 29.3811 32.2746 29.6575V31.7425C32.2746 32.019 32.1648 32.2842 31.9693 32.4797C31.7737 32.6752 31.5086 32.785 31.2321 32.785H20.8072C20.5308 32.785 20.2656 32.6752 20.0701 32.4797C19.8746 32.2842 19.7648 32.019 19.7648 31.7425V29.6575ZM3.08497 29.6575C3.08497 29.3811 3.19481 29.1159 3.39031 28.9204C3.58581 28.7249 3.85097 28.6151 4.12746 28.6151H14.5523C14.8288 28.6151 15.094 28.7249 15.2895 28.9204C15.485 29.1159 15.5948 29.3811 15.5948 29.6575V31.7425C15.5948 32.019 15.485 32.2842 15.2895 32.4797C15.094 32.6752 14.8288 32.785 14.5523 32.785H4.12746C3.85097 32.785 3.58581 32.6752 3.39031 32.4797C3.19481 32.2842 3.08497 32.019 3.08497 31.7425V29.6575ZM1 25.4876C1 25.2111 1.10983 24.946 1.30534 24.7505C1.50084 24.5549 1.766 24.4451 2.04249 24.4451H12.4673C12.7438 24.4451 13.009 24.5549 13.2045 24.7505C13.4 24.946 13.5098 25.2111 13.5098 25.4876V27.5726C13.5098 27.8491 13.4 28.1142 13.2045 28.3097C13.009 28.5052 12.7438 28.6151 12.4673 28.6151H2.04249C1.76594 28.6151 1.50097 28.505 1.30522 28.3098C1.10989 28.1142 1.00013 27.849 1 27.5726V25.4876ZM3.08497 21.3177C3.08497 21.0412 3.19481 20.776 3.39031 20.5805C3.58581 20.385 3.85097 20.2752 4.12746 20.2752H14.5523C14.8288 20.2752 15.094 20.385 15.2895 20.5805C15.485 20.776 15.5948 21.0412 15.5948 21.3177V23.4026C15.5948 23.6791 15.485 23.9443 15.2895 24.1398C15.094 24.3353 14.8288 24.4451 14.5523 24.4451H4.12746C3.85097 24.4451 3.58581 24.3353 3.39031 24.1398C3.19481 23.9443 3.08497 23.6791 3.08497 23.4026V21.3177ZM17.6798 25.4876C17.6798 25.2111 17.7896 24.946 17.9851 24.7505C18.1806 24.5549 18.4458 24.4451 18.7223 24.4451H29.1471C29.4236 24.4451 29.6888 24.5549 29.8843 24.7505C30.0798 24.946 30.1896 25.2111 30.1896 25.4876V27.5726C30.1896 27.8491 30.0798 28.1142 29.8843 28.3097C29.6888 28.5052 29.4236 28.6151 29.1471 28.6151H18.7223C18.4457 28.6151 18.1808 28.505 17.985 28.3098C17.7897 28.1142 17.6799 27.849 17.6798 27.5726V25.4876Z"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  culture_graph: (
    <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.1103 12.3872L28.3537 4.58301M13.3303 10.6989L18.9018 13.1719M1 16.1025L9.63816 10.919"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5862 23.4345L28.1741 19.7742M11.4249 24.4451H17.6798M1 28.6121L7.475 25.3746"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4251 11.9354C11.9781 11.9354 12.5085 11.7156 12.8995 11.3246C13.2905 10.9335 13.5101 10.4032 13.5101 9.85014C13.51 9.29714 13.2903 8.76679 12.8993 8.37579C12.5082 7.98478 11.9778 7.76513 11.4248 7.76517C10.8718 7.76521 10.3415 7.98493 9.95046 8.37599C9.55945 8.76705 9.33981 9.29743 9.33984 9.85043C9.33988 10.4034 9.5596 10.9338 9.95066 11.3248C10.3417 11.7158 10.8721 11.9354 11.4251 11.9354ZM20.8075 16.1054C21.3605 16.1053 21.8908 15.8856 22.2818 15.4945C22.6729 15.1035 22.8925 14.5731 22.8925 14.0201C22.8924 13.4671 22.6727 12.9367 22.2816 12.5457C21.8906 12.1547 21.3602 11.9351 20.8072 11.9351C20.2542 11.9352 19.7238 12.1549 19.3328 12.5459C18.9418 12.937 18.7222 13.4674 18.7222 14.0204C18.7223 14.5734 18.942 15.1037 19.333 15.4947C19.7241 15.8857 20.2545 16.1054 20.8075 16.1054ZM30.1899 5.68049C30.7429 5.68045 31.2732 5.46073 31.6642 5.06967C32.0552 4.67861 32.2749 4.14823 32.2748 3.59523C32.2748 3.04222 32.0551 2.51188 31.664 2.12087C31.273 1.72986 30.7426 1.51022 30.1896 1.51025C29.6366 1.51029 29.1062 1.73001 28.7152 2.12107C28.3242 2.51214 28.1046 3.04251 28.1046 3.59552C28.1046 4.14852 28.3244 4.67887 28.7154 5.06987C29.1065 5.46088 29.6369 5.68053 30.1899 5.68049Z"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.1899 21.3177C30.4637 21.3177 30.7348 21.2637 30.9878 21.1589C31.2408 21.0541 31.4706 20.9005 31.6642 20.7069C31.8578 20.5132 32.0114 20.2834 32.1162 20.0304C32.221 19.7774 32.2749 19.5063 32.2748 19.2324C32.2748 18.9586 32.2209 18.6875 32.1161 18.4345C32.0113 18.1815 31.8577 17.9517 31.664 17.7581C31.4704 17.5645 31.2405 17.4109 30.9875 17.3061C30.7345 17.2014 30.4634 17.1474 30.1896 17.1475C29.6366 17.1475 29.1062 17.3672 28.7152 17.7583C28.3242 18.1493 28.1046 18.6797 28.1046 19.2327C28.1046 19.7857 28.3244 20.3161 28.7154 20.7071C29.1065 21.0981 29.6369 21.3177 30.1899 21.3177ZM19.765 26.5301C20.0388 26.5301 20.31 26.4762 20.5629 26.3714C20.8159 26.2665 21.0458 26.1129 21.2394 25.9193C21.433 25.7257 21.5865 25.4958 21.6913 25.2428C21.7961 24.9898 21.85 24.7187 21.85 24.4449C21.85 24.171 21.796 23.8999 21.6912 23.6469C21.5864 23.394 21.4328 23.1641 21.2392 22.9705C21.0455 22.7769 20.8157 22.6233 20.5627 22.5186C20.3097 22.4138 20.0385 22.3599 19.7647 22.3599C19.2117 22.3599 18.6814 22.5796 18.2904 22.9707C17.8994 23.3618 17.6797 23.8921 17.6797 24.4452C17.6798 24.9982 17.8995 25.5285 18.2906 25.9195C18.6816 26.3105 19.212 26.5302 19.765 26.5301ZM9.34014 26.5301C9.61397 26.5301 9.8851 26.4762 10.1381 26.3714C10.391 26.2665 10.6209 26.1129 10.8145 25.9193C11.0081 25.7257 11.1617 25.4958 11.2665 25.2428C11.3712 24.9898 11.4251 24.7187 11.4251 24.4449C11.4251 24.171 11.3711 23.8999 11.2663 23.6469C11.1615 23.394 11.0079 23.1641 10.8143 22.9705C10.6207 22.7769 10.3908 22.6233 10.1378 22.5186C9.88482 22.4138 9.61368 22.3599 9.33986 22.3599C8.78685 22.3599 8.25651 22.5796 7.8655 22.9707C7.47449 23.3618 7.25484 23.8921 7.25488 24.4452C7.25492 24.9982 7.47464 25.5285 7.8657 25.9195C8.25676 26.3105 8.78714 26.5302 9.34014 26.5301Z"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1.5105V32.7851H32.2746"
        stroke="#522181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default iconOptions
